import { Component, computed, DestroyRef, ElementRef, HostListener, inject, Input, OnDestroy, OnInit, signal, ViewChild, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Map as OlMap, View } from 'ol';
import Feature from 'ol/Feature';
import VectorLayer from 'ol/layer/Vector';
// import 'ol/ol.css'; // CSS import causing build issues - moved to angular.json styles array
import Overlay from 'ol/Overlay';
import { fromLonLat, transform } from 'ol/proj';
import { register } from 'ol/proj/proj4';
import VectorSource from 'ol/source/Vector';
import { Coordinate } from 'ol/coordinate.js';
import { ObjectEvent } from 'ol/Object';
import { defaults as defaultControls } from 'ol/control.js';
import { FeatureLike } from 'ol/Feature';
import proj4 from 'proj4';
import { forkJoin, Subject } from 'rxjs';
import { Orthophoto, OrthoPhotoDto,OrthoLayer } from "src/app/bo/orthophoto";
import { take } from 'rxjs/operators';
import { HttpService } from 'src/app/services/http.service';
import { ControlPoint } from '../../bo/controlPoint';
import { DonneeAnalyseSiteDto } from '../../bo/donneeAnalyse';
import { ReferentielDonneeAnalyse } from '../../bo/referentielDonneeAnalyse';
import { Site } from '../../bo/site';
import { Tir } from '../../bo/tir';
import { TirsPolygoneType } from '../../bo/polygon/tirsPolygoneType';
import { UtilisateurService } from '../../services/utilisateur.service';
import { LoggerService } from '../../services/logger.service';
import { HoleDetails, HoleDTO, HoleLegendProperties, HoleFeatureLegendProperties, HoleService, HoleStatus } from 'src/app/services/hole.service';
import { FonctionsService } from 'src/app/services/fonctions-partagees.service';
import { CartStyleUtile } from 'src/app/utils/carteStyleUtile';
import Zoom from 'ol/control/Zoom';
import { TranslateService } from '@ngx-translate/core';
import { MeasureLayer, MEASURE_MODE } from './layers/Ruller';
import { ControlPointsLayer } from './layers/ControlPointsLayer';
import { MAP_VIEW_TYPE, MapLayersControler } from './layers/mapLayers'
import MapConstants from './constants';
import { BlastPolygonsLayer, ZoneColorPalette } from './layers/BlastPolygoneLayer';
import { HoleLayer } from './layers/holeLayer';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { SiteOrthophotosAddFilesModalComponent } from '../site-setup/site-orthophotos-add-files-modal/site-orthophotos-add-files-modal.component';
import { TirsPolygoneEnum } from 'src/app/bo/polygon/tirPolygoneEnum';
import { Geometry, Polygon as OlPolygon } from 'ol/geom';
import { TirContour } from 'src/app/bo/tirContour';
import { StaticUtils } from 'src/app/utils/staticUtils';
import { CarteHelpers } from './carteHelpers';
import { Equipment, EquipmentUtils } from 'src/app/bo/equipment';
import { EquipmentPosition } from 'src/app/bo/hiboo/equipmentPosition';
import { Shift, ShiftEnum, ShiftUtils } from 'src/app/bo/shifts/shift';
import { BlastEquipmentLayer } from './layers/BlastEquipmentLayer';
import { SitePolygonLayer } from './layers/SitePolygonLayer';
import { ZoneOfInterestLayer } from './layers/ZoneOfInterestLayer';
import { ZoneOfInterestService } from 'src/app/services/zone-of-interest.service';
import { ZoneOfInterestDto } from 'src/app/bo/zoneOfInterest';
import WKTFormat from 'ol/format/WKT';
import { DxfServiceService } from 'src/app/services/dxf-service.service';
import { OrthophotoMapService } from 'src/app/services/map.services';
import { PolygonType } from 'src/app/bo/polygon/tirsPolygone';
import { KpiService } from 'src/app/services/kpi.service';
import { EquipmentRoute, EquipmentRouteDto } from 'src/app/bo/equipment/equipmentRoute';
import { EquipmentRouteService } from 'src/app/services/equipment-route.service';

const ZOOM_THRESHOLD = 0.5;
const CvnSiteId = 189; //TODO: to be refactored to dynamically determine location-based values
const FEATURE_NAME= "featureType";
enum FEATURE_TYPE{blast_polygone, hole};


@Component({
  selector: 'app-carte',
  templateUrl: './carte.component.html',
  styleUrls: ['./carte.component.scss'],
  standalone: false
})

export class CarteComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() site: Site;
  @Input() blastIdToZoom: number = null;
  @ViewChild('popupForm', { static: false }) popupForm: ElementRef;
  @ViewChild('kpiJauge', { static: false }) kpiJauge: ElementRef; 
  @ViewChild('modalConfirmDeleteOrtho') modalConfirmDeleteOrtho: ModalDirective;
  @ViewChild('modalConfirmDeletePolygon') modalConfirmDeletePolygon: ModalDirective;

  private readonly destroyRef = inject(DestroyRef);
  popupOuverte = new Subject<number>();
  popupFermee = new Subject<number>();
  map: OlMap;

  popup;
  view = new View({
    center: transform([0, 0], MapConstants.EPSG_WGS84, MapConstants.EPSG_REFERENCE_OL),
    zoom: 15,
  });
  vectorsPolygone: VectorLayer<any>[] = [];
  holesVectorLayers: VectorLayer<any>[] = [];

  
  //listeControlPoints: ControlPoint[] = null;
  listePolygoneTypes: TirsPolygoneType[] = null;
  listeKPIActifs: ReferentielDonneeAnalyse[] = null; //liste de tous les KPI actifs du site (nom, unité, type, valeur min/max/nom)
  listeKPITirs: DonneeAnalyseSiteDto[]; //la liste de tous les KPI de tous les tirs sélectionnés (valeur, reférentielDonneeAnalyse associé TirId associé)
  listeTirs = signal<Tir[] | undefined>(undefined); //tous les tirs associés au site
  configSite: number[]; //les 4 KPI renseignés dans le setup site
  valKPISelectionne: { idTir: number, valeur: string, unite: string, couleur: string }[] = []; //valeur du KPI sélectionné pour tous les tirs sélectionnés
  defaultKPI: number = null;
  listeTirsSelectionnes: number[] = [];
  listeTypesSelectionnes: number[] = [];
  kpiSelectionne: ReferentielDonneeAnalyse; //le KPI sélectionné dans le treeview
  borneSup = 0;
  borneMoy = 0;
  readonly PolyEnum = TirsPolygoneEnum;
  selectedKPI: ReferentielDonneeAnalyse = null; // Pour le ng-select du KPI scale
  private kpiDataLoaded = false;
  borneInf = 0;
   private readonly dateRangeChangeTimeout: any;
  private previousDateRange: Date[] = [];
  tirPopup = signal<Tir | null>(null); //le tir associé au polygone sélectionné
  coordPolygones: number[] = [];
  popupTirActive = signal(false);
  kpiConfiguration = signal<{ nom: string, valeur: string, unite: string }[]>([]); //la valeur pour le tirPopup sélectionné des 4 KPI de référence
  valKPITir = signal<{ valeur: string, unite: string }>({ valeur: "", unite: "" }); //valeur à afficher sur le popup pour le KPI sélectionné dans le treeview
  proj4_site = "";
  
  // Propriétés pour la vue 3D
  is3DMode = false;
  originalViewRotation = 0;
  current3DAngle = 45; // Angle d'inclinaison en degrés
  current3DRotation = 0; // Rotation en degrés
  
  referentielOuvert: boolean;
  //listHoles: Hole[] = [];
  holePopup = signal<HoleDTO | null>(null);
  holePopupDetails = signal<HoleDetails | null>(null);
  activeTab = 'state';
  
  popupHoleActive = signal(false);
  blastsNamePopup = signal<string>('');
  showLegend = true
  polygonIDToDelete: number = null;
  cartStyleUtile = new CartStyleUtile();
  holesAreShown = false;
  holeToggle = true;
  controlPointsToggle = true;
  zoiToggle = true;
  inZoom = false; //used to determine if the holes should be shown after zooming in
  //MAP_VIEW_TYPE = MAP_VIEW_TYPE;
  layersPolygonesSelected: VectorLayer<any>[] = [];
  layersHolesSelected: VectorLayer<any>[] = [];
  //layerActiveType:MAP_VIEW_TYPE;
  showPopupForm = signal(false);
  timeSelection = signal('shift');
  selectedDate = signal<Date | undefined>(undefined);
  selectedDateRange = signal<Date[]>([]);
  selectedShift = signal<ShiftEnum | undefined>(undefined);
  selectedEquipments = signal<Equipment[]>([]);
  focusedEquipment = signal<Equipment | undefined>(undefined);
  shifts = Object.values(ShiftEnum).filter(value => typeof value === 'number');
  shiftsKeys = Object.keys(ShiftEnum).filter(k => !isNaN(Number(k)));
  today: Date = new Date();
  equipments: Equipment[];
  equipmentsPositions: EquipmentPosition[] = [];
  hasAppliedFilters = signal(false);
  equipmentLayer: VectorLayer<VectorSource<Feature<Geometry>>>;
  popupEquipmentActive = signal(false);
  isMouseInPopup = false;
  equipmentDisplayName: string;
  equipmentName: string;
  equipmentExternalId: number;
  formattedDate: string;
  formattedTime: string;
  equipmentLatitude: number;
  equipmentLongitude: number;
  equipmentAssignedShift: Shift | null;
  currentEquipmentPosition: EquipmentPosition | null;
  assignmentMode = signal(false);
  pendingEquipmentAssignment: EquipmentPosition | null;
  routeAssignmentMode = false; // Mode assignation de route à un blast
  shouldLoadSavedPositions: boolean;
  loadingEquipments = false;
  missingDateField = false;
  missingDateRangeField = false;
  missingShiftField = false;
  missingEquipmentField = false;
  showEquipmentButton = false;
  allView = signal(true);
  showAssignedEquipments = false;
  showEquipmentRoutes = true; // Activé par défaut pour les recherches

  // Time slider properties
  selectedTime = signal(0); // Temps sélectionné en minutes depuis minuit
  minTime = signal(0); // Heure de début en minutes
  maxTime = signal(1439); // Heure de fin en minutes (23:59)
  timeSliderEnabled = signal(false); // Actif seulement quand une date est sélectionnée

  // Equipment card expansion state
  expandedEquipmentCards = signal<Set<number>>(new Set());

  // Date and shift picker state
  isDateRangeExpanded = signal(false);

  // Route split mode state
  splitRouteMode = signal(false);

  // Route merge mode state
  mergeRouteMode = false;

  // Route sélectionnée pour fusion depuis les cards
  routeSelectedForMerge = signal<EquipmentRoute | null>(null);

  // Signal pour forcer le rafraîchissement des routes en zoneless
  routesVersion = signal(0);

  // Route drag & drop state
  draggingRoute = signal<EquipmentRoute | null>(null);
  dragTooltipVisible = false;
  dragTooltipText = '';
  dragTooltipX = 0;
  dragTooltipY = 0;

  // Route assignment state (pour assigner une route à un blast via clic)
  routeToAssignByClick = signal<EquipmentRoute | null>(null);

  holeLegendProperties: HoleLegendProperties[] = [];
  holeFeatureLegendProperties: HoleFeatureLegendProperties[] = [];
  showValKPITir = false;

  public activeButton = 1;// No button is active initially
  public bottomActiveButoon =0;
  private enablePolygonePicking = true;
  private enableHoleInteraction = true;
  private rulerControlLayer: MeasureLayer;
  private controlPointLayer: ControlPointsLayer;
  protected mapLayersControler: MapLayersControler;
  private blastPolygoneLayer: BlastPolygonsLayer;
  private equipmentLayerManager: BlastEquipmentLayer;
  private holeLayer: HoleLayer;
  private sitePolygonLayer: SitePolygonLayer;
  private zoneOfInterestLayer: ZoneOfInterestLayer;

  // ZOI drawing state
  protected zoiModalVisible = false;
  protected showZoiTypeModal = false;
  protected zoiName = '';
  protected zoiType = 0;
  protected zoiThreshold = 30;
  private zoiGeometryType = '';
  private zoiCenterX?: number;
  private zoiCenterY?: number;
  private zoiRadius?: number;
  private zoiWkt?: string;

  protected modalPolygoneTypeisVisible: boolean;
  protected modalValidationPolygoneisVisible: boolean;
    protected modalValidationPrePolygoneisVisible: boolean;
  protected optionsTirsPolygoneEnum: TirsPolygoneEnum[] = [TirsPolygoneEnum.MUCKPILE, TirsPolygoneEnum.DANGER_ZONE];
  protected optionsCarteTirsPolygoneEnum: TirsPolygoneEnum[] = [TirsPolygoneEnum.DRILLED, TirsPolygoneEnum.MUCKPILE, TirsPolygoneEnum.DANGER_ZONE];
  protected selectedTirsPolygoneEnum = TirsPolygoneEnum.MUCKPILE;
  protected cartSelectedTirsPolygoneEnum: TirsPolygoneEnum[] = [];
  @ViewChild('allViewCheckbox', { static: false }) allViewCheckbox: ElementRef<HTMLInputElement>;
  // Container des boutons du bas (présent dans les deux variantes : simple et scrollable)
  @ViewChild('bottomButtonsContainer') bottomButtonsContainer?: ElementRef<HTMLElement>;
  @ViewChild('topButtonsContainer') topButtonsContainer?: ElementRef<HTMLElement>;

  public selectedPolygonFeature: Feature = undefined;
  public selectedPolygonType: any = null;
  private polygonCoordinatesToSave: Coordinate[][] = [];
  
  preSelectedBlast: Tir = null;
  selectedBlastForPolygon: number = null;

  //menu right click
  menuVisible = false;
  menuPosition = { x: 0, y: 0 };
  menuTirSelected: Tir = undefined;

  showPolygonTypeModal = false;
  useZoneColors = false; 

  showHolesModal = false;

  selectedHoleStatusFilter: string | HoleStatus = 'actual';
  
  // Helper method to convert TirsPolygoneEnum to correct PolygonType numerical values
  private convertPolygonEnumToNumber(polygonEnum: TirsPolygoneEnum): number {
    switch (polygonEnum) {
      case TirsPolygoneEnum.AUTOMATIC:
        return 0; // AutomaticFromHoles
      case TirsPolygoneEnum.DRILLED:
        return 1; // DrillingContour
      case TirsPolygoneEnum.MUCKPILE:
        return 2; // MuckPile
      case TirsPolygoneEnum.DANGER_ZONE:
        return 3; // DangerZone
      default:
        return 1; // Default to DrillingContour
    }
  }
  
  // Propriété pour la suppression des orthophotos
  // Propriétés pour la gestion des orthophotos
  orthoToDelete: OrthoPhotoDto | null = null;
  selectedOrthoLayer: OrthoPhotoDto | null = null;
  selectedHoleFeatureFilter = 'all';

  isBottomButtonsOverflow = false; 
  bottomButtonsViewportHeight: number | null = null; 
  isTopButtonsOverflow = false; 
  
  isHolesModalOverflow = false; 
  
  // Removed static orthoLayers data - will use dynamic data from mapLayersControler
  
  private viewportListener?: () => void; 
  private recalcTimeout: any; 
  private lastDevicePixelRatio: number = window.devicePixelRatio; 
  private zoomCheckInterval: any; 
  showDeletePolygonConfirm = false;

  constructor(
    public utilService: UtilisateurService,
    private readonly http: HttpService,
    private readonly logger: LoggerService,
    private readonly holeService: HoleService,
    private readonly fonctionsService: FonctionsService,
    private readonly translate: TranslateService,
    private readonly dxfService: DxfServiceService,
    private readonly modalService: BsModalService,
    private readonly mapService: OrthophotoMapService,
    private readonly kpiService: KpiService,
    private readonly cdr: ChangeDetectorRef,
    private readonly equipmentRouteService: EquipmentRouteService,
    private readonly zoiService: ZoneOfInterestService
  ) {

    this.http.get<TirsPolygoneType[]>('TirsPolygoneType/tirsPolygoneType').pipe(takeUntilDestroyed(this.destroyRef)).subscribe(result => {
      this.listePolygoneTypes = result;
    });

    this.listeTypesSelectionnes = this.cartSelectedTirsPolygoneEnum.map(x => this.convertPolygonEnumToNumber(x))

  }

  ngOnChanges() {
    if (this.map == null) return;
    this.onChangeSite();

    if (this.site.siteId === CvnSiteId) {
      this.initializeEquipmentLayer();
    }else{
      this.showEquipmentButton = false;
    }
    
  }

  ngAfterViewInit(): void {
    this.evaluateBottomButtonsOverflow();
    this.evaluateTopButtonsOverflow();
    this.adjustTopRightButtonsPosition();
    setTimeout(() => this.evaluateBottomButtonsOverflow(), 100);
    setTimeout(() => this.evaluateTopButtonsOverflow(), 100);
    setTimeout(() => this.adjustTopRightButtonsPosition(), 100);
    
    if ((window as any).visualViewport) {
      this.viewportListener = () => {
        this.scheduleOverflowRecalc();
      };
      (window as any).visualViewport.addEventListener('resize', this.viewportListener, { passive: true });
    }

    window.addEventListener('load', () => {
      this.lastDevicePixelRatio = window.devicePixelRatio;
      // Essayer de calculer les features après que tout soit chargé
      // setTimeout(() => {
      //   this.calculateHoleFeatureLegendProperties();
      // }, 2000);
    });

    // Vérification périodique du zoom (fallback)
    this.zoomCheckInterval = setInterval(() => {
      if (window.devicePixelRatio !== this.lastDevicePixelRatio) {
        this.lastDevicePixelRatio = window.devicePixelRatio;
        this.scheduleOverflowRecalc();
      }
    }, 500);
  }

  @HostListener('window:resize') onWindowResize() {
    // Détection changement de DPR (zoom navigateur)
    if (window.devicePixelRatio !== this.lastDevicePixelRatio) {
      this.lastDevicePixelRatio = window.devicePixelRatio;
      
      if (this.recalcTimeout) clearTimeout(this.recalcTimeout);
      this.recalcTimeout = setTimeout(() => {
        this.adjustTopRightButtonsPosition();
        setTimeout(() => {
          this.evaluateBottomButtonsOverflow();
          this.evaluateTopButtonsOverflow();
        }, 20);
      }, 100);
      return;
    }
    
    this.scheduleOverflowRecalc();
  }


  ngOnInit() {
    this.referentielOuvert = true;
    this.createMap();

    const savedShowPopupForm = localStorage.getItem('showPopupForm');
    this.showPopupForm.set(savedShowPopupForm === 'true');
    
    const savedControlPointsToggle = localStorage.getItem('controlPointsToggle');
    this.controlPointsToggle = savedControlPointsToggle !== null ? savedControlPointsToggle === 'true' : true;

    const savedZoiToggle = localStorage.getItem('zoiToggle');
    this.zoiToggle = savedZoiToggle !== null ? savedZoiToggle === 'true' : true;
    
    this.loadPolygonToggles();

    this.onChangeSite();
    const isInit = true;

    this.popup = new Overlay({
      id: 'overlay',
      element: document.getElementById('popup')
    });

    this.map.addOverlay(this.popup);
    const popupElement = document.getElementById('popup');
    if (popupElement) {
      popupElement.addEventListener('mouseenter', () => {
        this.isMouseInPopup = true;
      });
      
      popupElement.addEventListener('mouseleave', () => {
        this.isMouseInPopup = false;
      });
    }
    
    const zoomInSvg = document.createElement('img');
    zoomInSvg.src = 'assets/icon/Zoom+.svg';
    zoomInSvg.style.width = '16px';
    zoomInSvg.style.height = '16px';

    const zoomOutSvg = document.createElement('img');
    zoomOutSvg.src = 'assets/icon/Zoom-.svg';
    zoomOutSvg.style.width = '16px';
    zoomOutSvg.style.height = '16px';

    let customZoom = new Zoom({ 
      className: 'custom-zoom',
      zoomInLabel: zoomInSvg,
      zoomOutLabel: zoomOutSvg
     });
    
    this.map.addControl(customZoom)
    

    this.onHover();
    this.onClick();
    this.onZoom();
    this.configureOnPan();

    this.mapLayersControler = new MapLayersControler(this.map, this.http, this.site, this.logger, 0, this.mapService);

    this.sitePolygonLayer = new SitePolygonLayer(this.dxfService, this.map, this.site.siteId, this.getDynamicZIndex(10), Number(this.site.epsg));
    this.zoneOfInterestLayer = new ZoneOfInterestLayer(this.zoiService, this.map, this.site.siteId, this.getDynamicZIndex(11));
    this.zoneOfInterestLayer.setVisible(this.zoiToggle);
    this.zoneOfInterestLayer.refresh();
    this.blastPolygoneLayer = new BlastPolygonsLayer(this.map, this.site.siteId, this.http, this.getDynamicZIndex(20));
    this.holeLayer = new HoleLayer(this.map, this.holeService, this.logger, this.getDynamicZIndex(30));

    this.holeLayer.holeLegend$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(updatedLegend => {
      this.holeLegendProperties = [...updatedLegend];
      // Aussi calculer les propriétés des features quand la légende des holes est mise à jour
      // this.calculateHoleFeatureLegendProperties();
    });

    this.controlPointLayer = new ControlPointsLayer(this.map, this.getDynamicZIndex(40));
    this.rulerControlLayer = new MeasureLayer(this.map, this.getDynamicZIndex(100));
    
    if (this.site.siteId === CvnSiteId){
      this.initializeEquipmentLayer();
    }else{
      this.showEquipmentButton = false;
    }
    
    this.getTypeChange();
    this.checkScreenSize();
    this.updateKpiScaleGradient();
  }
  @HostListener('window:resize')
  onResize() {
    this.checkScreenSize();
  }


  private createMap() {
    this.map = new OlMap({
      layers: null,
      controls: defaultControls({zoom: false}),
      target: 'map',
      view: this.view,
    });
    this.map.getView().on('change:resolution', () => this.updateCustomScale());
    this.updateCustomScale(); // init
  }

  private getDynamicZIndex(layerOffset: number): number {
    if (this.mapLayersControler) {
      return this.mapLayersControler.getRecommendedBaseZIndexForOtherLayers() + layerOffset;
    }
    return 10 + layerOffset;
  }
  getHoleIconForLegend(status: string): string {
    return this.holeLayer.getHoleIconPath(status);
  } 
private updateCustomScale() {
  const view = this.map.getView();
  const resolution = view.getResolution();
  const dpi = 25.4 / 0.28; 
  const metersPerUnit = view.getProjection().getMetersPerUnit();


  const nominalCount = resolution * dpi * metersPerUnit;
  const niceScale = this.getNiceScale(nominalCount);

  const scaleWidth = niceScale / metersPerUnit / resolution;

  const scaleText = document.getElementById('scale-text');
  const scaleBar = document.getElementById('scale-bar');

  if (scaleText && scaleBar) {
    scaleText.innerText = this.formatScaleLabel(niceScale);
    scaleBar.style.width = `${scaleWidth}px`;  }
}

private getNiceScale(rawLength: number): number {
  const scales = [1, 2, 5];
  const exponent = Math.floor(Math.log10(rawLength));
  const base = Math.pow(10, exponent);
  const factor = rawLength / base;

  let nice = scales.find(s => s >= factor);
  if (!nice) nice = 10;

  return nice * base;
}

private formatScaleLabel(length: number): string {
  return length >= 1000 ? `${length / 1000} km` : `${length} m`;
}

  ngOnDestroy() {
    if ((window as any).visualViewport && this.viewportListener) {
      (window as any).visualViewport.removeEventListener('resize', this.viewportListener);
    }

    if (this.recalcTimeout) {
      clearTimeout(this.recalcTimeout);
    }
    if (this.zoomCheckInterval) {
      clearInterval(this.zoomCheckInterval);
    }

    // Nettoyer les styles personnalisés appliqués aux boutons top-right
    this.resetTopRightButtonsStyles();
  }

  private resetTopRightButtonsStyles(): void {
    const topRightButtons = document.querySelector('.top-right-buttons') as HTMLElement;
    
    if (topRightButtons) {
      topRightButtons.style.removeProperty('--top-right-distance');
      topRightButtons.style.removeProperty('--top-right-gap');
      topRightButtons.style.removeProperty('--top-right-padding');
      topRightButtons.style.transform = '';
      topRightButtons.classList.remove('zoom-high', 'zoom-low');
    }
  }

 @HostListener('document:keydown.escape')
 onKeydownHandler() {
  this.map.getTargetElement().classList.remove('map-drawing');

  if (this.menuVisible) {
    this.menuVisible = false;
  }

  if (this.showPolygonTypeModal) {
    this.closePolygonTypeModal();
  }

  if (this.modalValidationPrePolygoneisVisible) {
    this.closeModalValidationPolygone();
  }

  if (this.activeButton == 1) return;

  this.clearDrawnPolygon();
  
  this.polygonCoordinatesToSave = [];
  this.selectedPolygonFeature = undefined;
  
  this.enablePolygonePicking = true;
  this.enableHoleInteraction = true;
  this.activeButton = 1;
  this.closePolygonTypeModal();
}

  @HostListener('document:click', ['$event']) onDocumentClick(event: MouseEvent) {
    if (this.showPopupForm() && this.popupForm && !this.popupForm.nativeElement.contains(event.target)) {
      if (!(event.target instanceof Element)) return;
      if (event.target.closest('.cdk-overlay-container, .ng-dropdown-panel')) {
        return;
      }
      this.closePopupForm();
    }
  }

  onWheel(event: WheelEvent) {
    if (this.timeSliderEnabled()) {
      event.preventDefault();
      const delta = Math.sign(event.deltaY);
      this.selectedTime.update(v => v - delta * 1); // Inverted: scroll down = forward in time (1 minute par scroll)
      if (this.selectedTime() < this.minTime()) {
        this.selectedTime.set(this.minTime());
      }
      if (this.selectedTime() > this.maxTime()) {
        this.selectedTime.set(this.maxTime());
      }
      this.onTimeSliderChange();
    }
  }

  @HostListener('document:contextmenu', ['$event'])
  onDocumentRightClick(event: MouseEvent) {
    event.preventDefault();
    this.selectedPolygonFeature = undefined;
    this.menuPosition = { x: event.clientX, y: event.clientY };

    this.menuVisible = !this.menuVisible;
    // Ne pas fermer la popup lors d'un clic droit
  }

  public toggleSplitRouteMode(): void {
    this.splitRouteMode.update(v => !v);
    // Désactiver le mode merge si on active le mode split
    if (this.splitRouteMode() && this.mergeRouteMode) {
      this.mergeRouteMode = false;
      this.routeSelectedForMerge.set(null);
      this.equipmentLayerManager.getRouteLayer().setMergeMode(false);
    }
    this.equipmentLayerManager.getRouteLayer().setSplitMode(this.splitRouteMode());
  }

  public toggleMergeRouteMode(): void {
    this.mergeRouteMode = !this.mergeRouteMode;
    // Désactiver le mode split si on active le mode merge
    if (this.mergeRouteMode && this.splitRouteMode()) {
      this.splitRouteMode.set(false);
      this.equipmentLayerManager.getRouteLayer().setSplitMode(false);
    }
    // Réinitialiser la sélection de fusion quand le mode merge est désactivé
    if (!this.mergeRouteMode) {
      this.routeSelectedForMerge.set(null);
    }
    this.equipmentLayerManager.getRouteLayer().setMergeMode(this.mergeRouteMode);
  }

  public toggleAssignmentMode(): void {
    this.assignmentMode.update(v => !v);
    if (this.assignmentMode()) {
      this.map.getViewport().style.cursor = 'crosshair';
    } else {
      this.map.getViewport().style.cursor = '';
      this.pendingEquipmentAssignment = null;
      this.routeToAssignByClick.set(null); // Nettoyer la route sélectionnée
    }
  }

  public layerSwitch(button: number) {
    if (button === 1) {
      this.mapLayersControler.toggleLayer(MAP_VIEW_TYPE.geoserver, !this.mapLayersControler.isOrthoLayerVisible);
    }
    else if (button === 2) {
      this.mapLayersControler.toggleLayer(MAP_VIEW_TYPE.ol, !this.mapLayersControler.isOSMLayerVisible);
    }
    else if (button === 3) {
      this.mapLayersControler.toggleLayer(MAP_VIEW_TYPE.bing, !this.mapLayersControler.isBingLayerVisible);
    }
    else if (button === 4) {
      this.toggle3DView();
    }
  }

  // Méthode pour basculer entre vue 2D et 3D
  public toggle3DView() {
    this.is3DMode = !this.is3DMode;
    
    if (this.is3DMode) {
      this.enable3DView();
    } else {
      this.disable3DView();
    }
  }

  // Activer la vue 3D avec effet pseudo-3D
  private enable3DView() {
    const view = this.map.getView();
    
    // Sauvegarder la rotation actuelle
    this.originalViewRotation = view.getRotation();
    
    // Réinitialiser les angles 3D
    this.current3DAngle = 45;
    this.current3DRotation = 0;
    
    // Appliquer une rotation initiale pour simuler un angle 3D
    view.animate({
      rotation: Math.PI / 6, // 30 degrés
      duration: 1000
    });
    
    // Ajouter la classe CSS pour l'effet 3D et appliquer la transformation
    const mapElement = document.getElementById('map');
    if (mapElement) {
      mapElement.classList.add('map-3d-mode');
      this.update3DTransform();
    }
    
    // Ajouter des ombres aux couches pour l'effet 3D
    this.add3DEffects();
  }

  // Désactiver la vue 3D et revenir en 2D
  private disable3DView() {
    const view = this.map.getView();
    
    // Restaurer la rotation originale
    view.animate({
      rotation: this.originalViewRotation,
      duration: 1000
    });
    
    // Supprimer la classe CSS 3D
    const mapElement = document.getElementById('map');
    if (mapElement) {
      mapElement.classList.remove('map-3d-mode');
    }
    
    // Supprimer les effets 3D des couches
    this.remove3DEffects();
  }

  // Ajuster l'angle d'inclinaison 3D
  public adjust3DAngle(delta: number) {
    if (!this.is3DMode) return;
    
    this.current3DAngle = Math.max(0, Math.min(80, this.current3DAngle + delta));
    this.update3DTransform();
  }

  // Faire tourner la vue 3D
  public rotate3DView(delta: number) {
    if (!this.is3DMode) return;
    
    this.current3DRotation += delta;
    this.update3DTransform();
    
    // Mettre à jour aussi la rotation de la carte OpenLayers
    const view = this.map.getView();
    const newRotation = view.getRotation() + (delta * Math.PI / 180);
    view.animate({
      rotation: newRotation,
      duration: 300
    });
  }

  // Réinitialiser la vue 3D
  public reset3DView() {
    if (!this.is3DMode) return;
    
    this.current3DAngle = 45;
    this.current3DRotation = 0;
    this.update3DTransform();
    
    // Réinitialiser la rotation de la carte
    const view = this.map.getView();
    view.animate({
      rotation: this.originalViewRotation,
      duration: 500
    });
  }

  // Mettre à jour la transformation 3D
  private update3DTransform() {
    const mapElement = document.getElementById('map');
    if (mapElement) {
      const transform = `perspective(1000px) rotateX(${this.current3DAngle}deg) rotateZ(${this.current3DRotation}deg)`;
      mapElement.style.transform = transform;
    }
  }

  // Gestion des événements clavier pour les contrôles 3D
  @HostListener('window:keydown', ['$event'])
  handle3DKeyboard(event: Event) {
    if (!this.is3DMode) return;
    const kbEvent = event as KeyboardEvent;
    
    switch(kbEvent.key) {
      case 'ArrowUp':
        if (kbEvent.ctrlKey) {
          this.adjust3DAngle(5);
          kbEvent.preventDefault();
        }
        break;
      case 'ArrowDown':
        if (kbEvent.ctrlKey) {
          this.adjust3DAngle(-5);
          kbEvent.preventDefault();
        }
        break;
      case 'ArrowLeft':
        if (kbEvent.ctrlKey) {
          this.rotate3DView(-15);
          kbEvent.preventDefault();
        }
        break;
      case 'ArrowRight':
        if (kbEvent.ctrlKey) {
          this.rotate3DView(15);
          kbEvent.preventDefault();
        }
        break;
      case 'r':
        if (kbEvent.ctrlKey) {
          this.reset3DView();
          kbEvent.preventDefault();
        }
        break;
    }
  }

  // Ajouter des effets visuels 3D aux couches
  private add3DEffects() {
    // Ajouter des ombres et des effets de hauteur aux polygones
    this.map.getLayers().forEach((layer) => {
      if (layer instanceof VectorLayer) {
        const element = layer.getRenderer();
        // Ici nous pouvons modifier les styles pour simuler la hauteur
        this.apply3DStyleToLayer(layer);
      }
    });
  }

  // Supprimer les effets 3D
  private remove3DEffects() {
    this.map.getLayers().forEach((layer) => {
      if (layer instanceof VectorLayer) {
        this.removeStyleFromLayer(layer);
      }
    });
  }

  // Appliquer un style 3D à une couche
  private apply3DStyleToLayer(layer: VectorLayer<any>) {
    // Cette méthode peut être étendue pour appliquer des styles spécifiques
    // selon le type de couche (polygones, points, etc.)
    const source = layer.getSource();
    if (source) {
      source.getFeatures().forEach(feature => {
        // Ici nous pouvons modifier les styles individuels des features
        // pour simuler des effets de hauteur ou d'extrusion
      });
    }
  }

  // Supprimer les styles 3D d'une couche
  private removeStyleFromLayer(layer: VectorLayer<any>) {
    // Restaurer les styles originaux
    const source = layer.getSource();
    if (source) {
      source.getFeatures().forEach(feature => {
        // Restaurer les styles par défaut
      });
    }
  }

  onZoom() {
    this.map.getView().on('change:resolution', (event: ObjectEvent) => {
      
      if (event.oldValue == null) return;

      const currentResolution = this.map.getView().getResolution();
      
      if (currentResolution < ZOOM_THRESHOLD) {
        this.handleZoomIn();
      } else {
        this.holesAreShown = false;
        this.inZoom = false;
        this.updateHoleVisibility(); // Cacher les holes quand on dézoom
      }
    });
  }
    private handleZoomIn() {
    if (!this.holesAreShown && this.holeToggle) {
      this.holesAreShown = true;
      this.inZoom = true;
 
      return;
    }
    if (this.holesAreShown && this.holeToggle) {
      this.inZoom = true;
      return;
    }
    this.holesAreShown = false;
    this.inZoom = true;
    this.updateHoleVisibility(); // Cacher les holes
  }


  onHover(){
    let selected = null;
    let tooltip = document.getElementById('map-tooltip');
    
    // Créer l'élément tooltip s'il n'existe pas
    if (!tooltip) {
      tooltip = document.createElement('div');
      tooltip.id = 'map-tooltip';
      tooltip.style.position = 'absolute';
      tooltip.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
      tooltip.style.color = 'white';
      tooltip.style.padding = '5px 8px';
      tooltip.style.borderRadius = '4px';
      tooltip.style.fontSize = '12px';
      tooltip.style.pointerEvents = 'none';
      tooltip.style.zIndex = '1000';
      tooltip.style.display = 'none';
      tooltip.style.whiteSpace = 'pre-line';
      tooltip.style.maxWidth = '200px';
      document.body.appendChild(tooltip);
    }
    
    this.map.on('pointermove', (evt) => {
      if (selected !== null) {
        // Ne pas réinitialiser le style des équipements (géré par la timeline)
        if (!selected.get('equipmentType')) {
          const savedStyle = selected.get('_savedStyle');
          selected.setStyle(savedStyle !== undefined ? savedStyle : undefined);
          selected.unset('_savedStyle');
        }
        selected = null;
      }

      // Cacher le tooltip par défaut
      tooltip.style.display = 'none';
      if (this.isMouseInPopup) {
        return;
      }

      const pixel = this.map.getEventPixel(evt.originalEvent);
      const hit = this.map.hasFeatureAtPixel(pixel);
      this.map.getTargetElement().style.cursor = hit ? 'pointer' : '';

      let feature = this.map.forEachFeatureAtPixel(evt.pixel, (feature) => {
        selected = feature;
        if (selected instanceof Feature) {
          selected.set('_savedStyle', selected.getStyle(), true);
        }
        return feature;
      });
  
      if (feature) {
        let tooltipText = '';
        
        if(feature.get(FEATURE_NAME) == FEATURE_TYPE.blast_polygone){
          const fillColor = feature.get(MapConstants.HOVER_FILL_COLOR);
          const style = CartStyleUtile.polygoneStyleHover(fillColor);
          selected.setStyle(style);
          feature = selected;
          
          // Obtenir le nom du blast et sa date prévisionnelle
          const tirId = feature.get(MapConstants.TIR_ID)?.value;
          const blast = this.listeTirs()?.find(tir => tir.tirId === tirId);
          let blastTooltip = blast?.nom || 'Blast';
          
          // Ajouter la date prévisionnelle si disponible
          if (blast?.dateTirPrevisionnelle) {
            const datePrevisionnelle = new Date(blast.dateTirPrevisionnelle);
            const datePrevStr = this.formatDateToDDMMYYYY(datePrevisionnelle);
            blastTooltip += `\n${datePrevStr}`;
          }
          
          tooltipText = blastTooltip;
        }
        
        if(feature.get(FEATURE_NAME) == FEATURE_TYPE.hole){
          const style = CartStyleUtile.holeStyleHover();
          selected.setStyle(style);

          // Obtenir le nom du hole
          const hole = feature.get(MapConstants.HOLE_OBJECT);
          tooltipText = hole?.name || 'Hole';
        }

        if(feature.get(FEATURE_NAME) == MapConstants.FEATURE_TYPE.zone_of_interest){
          const zoiData = feature.get(MapConstants.ZOI_DATA);
          const style = CartStyleUtile.zoiStyleHover(zoiData?.name);
          selected.setStyle(style);
          tooltipText = zoiData?.name || 'Zone of Interest';
        }
        
        // Vérifier si c'est un segment de route d'équipement
        if(feature.get('isVisualSegment')){
          // Récupérer les données du segment
          const equipmentId = feature.get('equipmentId');
          const startTime = feature.get('startTime');
          const endTime = feature.get('endTime');
          const parentRouteId = feature.get('parentRouteId');

          // Trouver la route parente pour obtenir equipmentName et tirId
          let equipmentName = `Equipment ${equipmentId}`;
          let tirId: number | undefined;

          if (this.equipmentLayerManager) {
            const routeLayer = this.equipmentLayerManager.getRouteLayer();
            const routes = routeLayer.getRoutes();
            const parentRoute = routes.find(r => {
              const routeId = r.equipmentId + '_' + r.dayKey + '_' + r.startTime.getTime();
              return routeId === parentRouteId;
            });

            if (parentRoute) {
              equipmentName = parentRoute.equipmentName;
              tirId = parentRoute.tirId;
            }
          }

          // Formater la date
          const routeDate = startTime ? this.formatDateToDDMMYYYY(new Date(startTime)) : '';

          // Formater les heures
          const formatTime = (date: Date): string => {
            const hours = date.getHours().toString().padStart(2, '0');
            const minutes = date.getMinutes().toString().padStart(2, '0');
            return `${hours}:${minutes}`;
          };

          const startTimeStr = startTime ? formatTime(new Date(startTime)) : '';
          const endTimeStr = endTime ? formatTime(new Date(endTime)) : '';

          // Construire le tooltip
          let routeTooltipLines: string[] = [];
          routeTooltipLines.push(equipmentName);

          if (routeDate) {
            routeTooltipLines.push(routeDate);
          }

          if (startTimeStr && endTimeStr) {
            routeTooltipLines.push(`${startTimeStr} - ${endTimeStr}`);
          }

          // Ajouter le nom du blast si assigné
          if (tirId) {
            const blast = this.listeTirs()?.find(tir => tir.tirId === tirId);
            if (blast?.nom) {
              routeTooltipLines.push(`Blast: ${blast.nom}`);
            }
          }

          tooltipText = routeTooltipLines.join('\n');
        }

        // Vérifier si c'est un équipement
        if(feature.get('equipmentType')){
          const equipment = feature.get('equipment');
          let baseTooltip = equipment?.displayName || equipment?.name || 'Equipment';
          
          // Obtenir la date de position de l'équipement
          const positionData = feature.get('positionData');
          let positionDateStr = '';
          
          if (positionData && positionData.date) {
            const positionDate = new Date(positionData.date);
            positionDateStr = this.formatDateToDDMMYYYY(positionDate);
          }
          
          // Vérifier si l'équipement est assigné à un shift (utiliser la même logique que checkEquipmentAssignment)
          if (equipment && positionData && this.equipmentLayerManager) {
            const shifts = this.equipmentLayerManager.getShifts();
            const positionDate = new Date(positionData.date);
            const equipmentId = positionData.equipmentExternalId;
            
            // Chercher le shift qui correspond à cette position d'équipement
            const matchingShift = shifts.find(shift => {
              if (shift.isDeleted || !shift.equipementsIds) return false;
              
              // Vérifier si l'équipement est dans ce shift
              const equipmentIds = shift.equipementsIds.split(';').map(id => parseInt(id.trim(), 10));
              const isEquipmentInShift = equipmentIds.includes(equipmentId);
              
              if (!isEquipmentInShift) return false;
              
              // Vérifier si l'heure de position correspond au shift
              const shiftDate = new Date(shift.date);
              
              if (shift.time === ShiftEnum.NightToMorning) {
                // Pour les shifts de nuit : 
                // - Les positions 0h-6h du jour J appartiennent au shift de nuit du jour J-1
                // - Les positions 22h-23h du jour J appartiennent au shift de nuit du jour J
                const positionHour = positionDate.getHours();
                const positionDateOnly = new Date(positionDate.getFullYear(), positionDate.getMonth(), positionDate.getDate());
                const shiftDateOnly = new Date(shiftDate.getFullYear(), shiftDate.getMonth(), shiftDate.getDate());
                const dayBeforeShift = new Date(shiftDateOnly.getTime() - 24 * 60 * 60 * 1000);
                
                // Plage 1: Soir du jour J (22h à 23h59) - même date que le shift
                if (positionHour >= 22 && positionHour <= 23) {
                  return positionDateOnly.getTime() === shiftDateOnly.getTime();
                }
                
                // Plage 2: Matin du jour J (0h à 5h59) - appartient au shift de la veille (J-1)
                if (positionHour >= 0 && positionHour < 6) {
                  const dayAfterShift = new Date(shiftDateOnly.getTime() + 24 * 60 * 60 * 1000);
                  return positionDateOnly.getTime() === dayAfterShift.getTime();
                }
                
                return false;
              } else {
                // Pour les autres shifts
                const timeRange = ShiftUtils.calculateShiftTimeRange(shiftDate, shift.time);
                return positionDate >= timeRange.startDate && positionDate <= timeRange.endDate;
              }
            });
            
            if (matchingShift) {
              // Si assigné : afficher nom + date du shift + nom du shift
              const shiftDate = new Date(matchingShift.date);
              
              // Pour les shifts de nuit (22h-6h), afficher la date +1 car le shift couvre deux jours
              let displayDate = new Date(shiftDate);
              if (matchingShift.time === ShiftEnum.NightToMorning) {
                displayDate.setUTCDate(displayDate.getUTCDate() + 1);
              }
              
              const shiftDateStr = this.formatDateToDDMMYYYY(displayDate);
              const shiftName = ShiftUtils.formatShiftLabel(matchingShift.time);
              const translatedShiftName = this.translate.instant(shiftName);
              
              tooltipText = `${baseTooltip}\n ${shiftDateStr}\n ${translatedShiftName}`;
            } else {
              // Si non assigné : afficher nom + date de position
              tooltipText = positionDateStr ? `${baseTooltip}\n ${positionDateStr}` : baseTooltip;
            }
          } else {
            // Si pas d'equipmentLayerManager ou pas de données : afficher nom + date de position si disponible
            tooltipText = positionDateStr ? `${baseTooltip}\n ${positionDateStr}` : baseTooltip;
          }
        }
        
        // Afficher le tooltip si on a du texte
        if (tooltipText) {
          tooltip.textContent = tooltipText;
          tooltip.style.display = 'block';
          
          // Type guard: check if originalEvent has clientX/clientY
          const originalEvent = evt.originalEvent;
          if ('clientX' in originalEvent && 'clientY' in originalEvent) {
            tooltip.style.left = (originalEvent.clientX + 10) + 'px';
            tooltip.style.top = (originalEvent.clientY - 25) + 'px';
          }
        }
      }
    })
    }
  onClick() {
    if (this.enablePolygonePicking) {
      this.map.on('click', (evt) => {
          if (this.activeButton === 3) {
        return;
      }
        let features = this.map.getFeaturesAtPixel(evt.pixel);
        
        // Gestion du mode d'assignation d'équipement ou de route
        if (this.assignmentMode()) {
          if (features && features.length > 0) {
            // Chercher un polygone de blast pour l'assignation
            let polygonFeature = features.find(f => {
              return f.get(MapConstants.FEATURE_NAME) == MapConstants.FEATURE_TYPE.blast_polygone;
            });

            if (polygonFeature) {
              const tirId = polygonFeature.get(MapConstants.TIR_ID).value;

              // Si une route est sélectionnée pour assignation, l'assigner
              if (this.routeToAssignByClick()) {
                this.assignRouteToBlastById(this.routeToAssignByClick(), tirId);
                this.routeToAssignByClick.set(null); // Désélectionner après assignation
                return;
              }

              // Sinon, assigner l'équipement (comportement original)
              this.assignEquipmentToBlast(tirId);
              return;
            }
          }

          // Si pas de polygone trouvé et une route était sélectionnée, juste désélectionner
          if (this.routeToAssignByClick()) {
            this.routeToAssignByClick.set(null);
            return;
          }

          // Si pas de polygone trouvé, annuler le mode assignation
          this.cancelAssignmentMode();
          return;
        }

        // Gestion du mode d'assignation de route à un blast
        if (this.routeAssignmentMode) {
          if (features && features.length > 0) {
            // Chercher un polygone de blast pour l'assignation
            let polygonFeature = features.find(f => {
              return f.get(MapConstants.FEATURE_NAME) == MapConstants.FEATURE_TYPE.blast_polygone;
            });

            if (polygonFeature) {
              const tirId = polygonFeature.get(MapConstants.TIR_ID).value;
              this.assignRouteToBlast(tirId);
              return;
            }
          }

          // Si pas de polygone trouvé, annuler le mode assignation de route
          this.cancelRouteAssignmentMode();
          return;
        }
        
        if (features && features.length > 0 && !this.modalPolygoneTypeisVisible) {
          // Chercher d'abord les équipements
          let equipmentFeature = features.find(f => f.get(MapConstants.EQUIP_TYPE));
          if (equipmentFeature) {
            const positionData = equipmentFeature.get(MapConstants.POSITION_DATA);
            this.createPopupEquipment(evt.coordinate as Coordinate, positionData);
            return; // Priorité aux équipements
          }
          
          if (this.enableHoleInteraction) {
            let holeFeature = features.find(f => 
              f.get(MapConstants.FEATURE_NAME) == MapConstants.FEATURE_TYPE.hole
            );
            if (holeFeature) {
              const blastName = holeFeature.get(MapConstants.BLAST_NAME);
              const hole = holeFeature.get(MapConstants.HOLE_OBJECT);
              this.createPopupHole(evt.coordinate as Coordinate, hole, blastName);
              return; // Priorité aux holes
            }
          }
          
          // Enfin chercher les polygones
          let polygonFeature = features.find(f => {
            return f.get(MapConstants.FEATURE_NAME) == MapConstants.FEATURE_TYPE.blast_polygone;
          });
          if (polygonFeature && !this.showPolygonTypeModal) {
            const tirId = polygonFeature.get(MapConstants.TIR_ID).value;
            this.polygonIDToDelete = polygonFeature.get(MapConstants.POLYGONE_ID);
            this.selectedPolygonType = polygonFeature.get(MapConstants.POLYGONE_TYPE);
            this.selectedPolygonFeature = new Feature();
            this.selectedPolygonFeature.set(MapConstants.TIR_ID, tirId);
            this.selectedPolygonFeature.set(MapConstants.FEATURE_NAME, MapConstants.FEATURE_TYPE.blast_polygone);
            this.selectedPolygonFeature.setGeometry(polygonFeature.getGeometry() as Geometry);
            this.createPopupTir(evt.coordinate as Coordinate, tirId, evt.coordinate as Coordinate);
            return;
          }
        }
        
        this.closePopup();
      });
    }
  }

  private configureOnPan() {
  this.map.on('moveend', (evt) => {
      this.RefreshHoles(); 
  });
}

private RefreshHoles(): void {
  
  const viewExtent = this.map.getView().calculateExtent(this.map.getSize());
  const visibleBlasts = this.blastPolygoneLayer.findPolygoneInView(viewExtent);

  let blastIdsInView = [];
  for (var feature of visibleBlasts) {
    var blastId = feature.get(MapConstants.TIR_ID).value;
    if (!blastIdsInView.includes(blastId)) {
      blastIdsInView.push(blastId);
    }             
  }
  
  this.holeLayer.refreshHoles(blastIdsInView, this.holesAreShown, this.listeTirsSelectionnes, this.getVisibleHoleStatuses(), this.selectedHoleStatusFilter as HoleStatus, this.selectedHoleFeatureFilter);
  
  // Les statistiques des features seront calculées lors des changements de filtres
}
  setMouseCoordinates() {
    var coord = [0, 0];
    var epsg;
    let isDegre = true;
    var C1 = 'X', C2 = 'Y';
    if (null !== this.site.epsg && undefined !== this.site.epsg) {
      epsg = "EPSG:" + this.site.epsg;
      if (undefined !== this.site.epsg && '4326' !== this.site.epsg) {
        isDegre = false;
      }
    }
    else {
      epsg = "EPSG:4326";
      isDegre = true;
    }

    if (isDegre) {
      C1 = 'G', C2 = 'L';
    }

    const element = document.getElementById('mouse-position');

    if (element) {
      element.innerHTML =
        epsg
        + '<br/>' + C1 + ': ' + '0'
        + '<br/>' + C2 + ': ' + '0';
    }

    this.map.on('pointermove', function (evt) {
    coord = evt.coordinate;
    coord = transform(coord, MapConstants.EPSG_REFERENCE_OL, epsg);
    document.getElementById('mouse-position').innerHTML = `
    <span class="mouse-pos-text">
      ${epsg}<br/>${C1}: ${(isDegre ? coord[0].toFixed(4) : coord[0].toFixed(0))}<br/>${C2}: ${(isDegre ? coord[1].toFixed(4) : coord[1].toFixed(0))}
    </span>`;
});
  }
  

  public onDeletePolygonClick() {
    if (this.modalConfirmDeletePolygon) {
      this.modalConfirmDeletePolygon.show();
    }
  }


  public confirmDeletePolygon() {
    if (this.polygonIDToDelete) {
      this.deleteBlastPolygon(this.polygonIDToDelete);
      this.closePopup();
    }
    if (this.modalConfirmDeletePolygon) {
      this.modalConfirmDeletePolygon.hide();
    }
  }


  public cancelDeletePolygon() {
    if (this.modalConfirmDeletePolygon) {
      this.modalConfirmDeletePolygon.hide();
    }
  }
  createPopupTir(coordinates: Coordinate, idTir: number, coordinatesPanTo: Coordinate, shouldPan = true) {
    if (this.modalValidationPrePolygoneisVisible) {
      return;
    }
    
    this.closePopup();
    this.holePopup.set(null);
    this.popupHoleActive.set(false);
    this.popupOuverte.next(idTir);

    if (shouldPan) {
      var zoom = this.view.getZoom();
      if (this.site.epsg != null && this.site.epsg != undefined && this.site.epsg != '') {
        let coordModif: number[] = transform(coordinatesPanTo, MapConstants.EPSG_REFERENCE_OL, 'EPSG:' + this.site.epsg);
        this.panTo({ coord: coordModif, zoom: zoom });
      }
    }

    this.popupTirActive.set(true);
    this.tirPopup.set(this.listeTirs()?.find(element => element.tirId == idTir) ?? null);
    const kpiConfig: { nom: string, valeur: string, unite: string }[] = [];
    this.putValKPIPopup();
    if (this.site.configurationKPI != "" && this.listeKPITirs?.length > 0) {
      this.configSite = JSON.parse(this.site.configurationKPI);
      const currentTirPopup = this.tirPopup();
      if (currentTirPopup) {
        for (let i = 0; i < 4; i++) {
          if (this.configSite[i] != null) {
            var valeur = this.listeKPITirs.find(element => element.referentielDonneeAnalyseId === this.configSite[i] && element.tirId === currentTirPopup.tirId);
            if (valeur != null) {
              const kpiDef = this.listeKPIActifs?.find(element => element.referentielDonneeAnalyseId === this.configSite[i]);
              if (kpiDef) {
                kpiConfig[i] = {
                  nom: kpiDef.nom,
                  valeur: valeur.valeur,
                  unite: valeur.unite ?? ""
                };
              }
            }
          }
        }
      }
    }
    this.kpiConfiguration.set(kpiConfig);
    this.popup.setPosition(coordinates);
  }

  //crée la popup pour hole
  createPopupHole(coordinates: Coordinate, hole: HoleDTO, blastName: string) {
    if (this.modalValidationPrePolygoneisVisible) {
      return;
    }

    this.holeService.GetHoleDetail(hole.publicGuid).then((holeDetails) => {
      this.holePopupDetails.set(holeDetails);
      this.blastsNamePopup.set(blastName);
      this.tirPopup.set(null);
      this.popupTirActive.set(false);
      var zoom = this.view.getZoom();
      let coordModif: number[] = transform(coordinates, MapConstants.EPSG_REFERENCE_OL, 'EPSG:' + this.site.epsg);
      this.panTo({ coord: coordModif, zoom: zoom });
      this.popupHoleActive.set(true);
  
      this.holePopup.set(hole);
  
      this.popup.setPosition(coordinates);
    });
  }

  closePopup() {
    // document.getElementById('popup-closer').blur();
    if (this.popup) {
      this.popup.setPosition(undefined);
    }
    this.popupTirActive.set(false);
    this.popupHoleActive.set(false);
    const currentTir = this.tirPopup();
    this.popupFermee.next(Number((currentTir !== null && currentTir != undefined && currentTir.tirId != null) ? currentTir.tirId : undefined));
    this.focusedEquipment.set(undefined);
    if (this.popupEquipmentActive()) {
      this.popupEquipmentActive.set(false);
    }
  }

  putValKPIPopup() {
    this.valKPITir.set({ valeur: "", unite: "" });
    const currentTir = this.tirPopup();
    if (this.kpiSelectionne !== null && this.kpiSelectionne !== undefined && currentTir != undefined && this.valKPISelectionne?.length > 0) {
      var valSelection = this.valKPISelectionne.find(e => e.idTir === currentTir.tirId);
      if (valSelection != undefined) {
        this.valKPITir.set({
          valeur: valSelection.valeur,
          unite: valSelection.unite
        });
      }
    }
  }

  //bouger la carte vers les coordonnées du site
  panTo(val: any) {
    if (null != this.site.epsg) {
      const tab = val['coord'];
      const coord = transform(tab, 'EPSG:' + this.site.epsg, MapConstants.EPSG_REFERENCE_OL);
      this.view.animate({
        zoom: val['zoom'],
        center: coord,
      });
    }
    else {
      //center in France if no coordinate ;)
      this.view.animate({
        zoom: val['zoom'],
        center: fromLonLat([4.7778, 43.6080]),
      });
    }
  }

  onChangeSite() {
    if (this.tirPopup != undefined)
      this.closePopup();
    if (this.showPopupForm()) {
      this.closePopupForm();
    }
    this.selectedEquipments.set([]);
    if (this.bottomActiveButoon === 3) {
      this.bottomActiveButoon = 0;
    }
    
    if (this.site.configurationKPI != "") {
      this.configSite = JSON.parse(this.site.configurationKPI);
      this.defaultKPI = this.configSite[0];
    }
    this.kpiDataLoaded = false;
    this.kpiSelectionne = null;
    this.selectedKPI = null;
    forkJoin([this.http.get<Tir[]>('Sites/' + this.utilService.currentSite().siteId + '/Blasts'),
    this.http.get<ControlPoint[]>('Sites/' + this.site.siteId + '/ControlPoints?transformCoord=false'),
    this.kpiService.getSiteActiveAnalysisEntry(this.utilService.currentSite().siteId),
    this.http.get<string>('Sites/proj4/' + this.site.epsg),
    this.http.get<string>('Sites/proj4/' + MapConstants.EPSG_REFERENCE_OL),
    ])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(resultat => {
        this.listeTirs.set(resultat[0]);
        this.listeKPIActifs = resultat[2];
        this.proj4_site = resultat[3];
        
        this.blastPolygoneLayer.setBlastsData(this.listeTirs());
        
        if(null !== this.equipmentLayerManager && undefined !== this.equipmentLayerManager){
          this.equipments = this.equipmentLayerManager.getEquipments();

          this.equipments = this.equipments?.map(equipment => ({
            ...equipment,
            displayName: EquipmentUtils.getEquipmentTypeFromEquipment(equipment) + " - " + EquipmentUtils.formatEquipmentDisplayName(equipment)
          }));
        }

        this.registerProjString(this.proj4_site);

        this.setMouseCoordinates();
        this.panTo({ coord: [this.site.coordX, this.site.coordY], zoom: 15 });

        this.mapLayersControler.ChangeSite(this.site);
        this.blastPolygoneLayer.changeSite(this.site.siteId);
        this.sitePolygonLayer.changeSite(this.site.siteId, Number(this.site.epsg));
        this.zoneOfInterestLayer.changeSite(this.site.siteId);
        this.controlPointLayer.setControlPoints(resultat[1].filter(cp => cp.isActif));
        this.controlPointLayer.setVisible(this.controlPointsToggle);
        this.holeLayer.clear();

      if ((this.listeTirs()?.length ?? 0) > 0) {
      let kpiTirs = this.http.get<DonneeAnalyseSiteDto[]>('Sites/' + this.site.siteId + '/AnalysisDataValues');
      kpiTirs.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(resultat => {
        this.listeKPITirs = resultat;
        
        this.kpiDataLoaded = true;
        this.setDefaultKPI();
        
        if (this.kpiSelectionne !== null && this.kpiSelectionne !== undefined && this.listeKPITirs !== undefined)
          this.getValeurKPITirs();
      });
    } else {
      this.kpiDataLoaded = true;
      this.setDefaultKPI();
    }

    if (this.blastIdToZoom) {
        setTimeout(() => {
          this.zoomToBlast(this.blastIdToZoom);
        }, 1000);
      }
  });

      
  }
private setDefaultKPI(): void {
  if (this.defaultKPI && this.listeKPIActifs && this.kpiDataLoaded) {
    this.selectedKPI = this.listeKPIActifs.find(kpi => 
      kpi.referentielDonneeAnalyseId === this.defaultKPI
    );
    
    if (this.selectedKPI) {
    }
  }
  
  setTimeout(() => {
    this.updateKpiScaleGradient();
  }, 200);
}



  registerProjString(projString: string) {
    if (undefined !== projString && null !== projString && projString != "") {
      proj4.defs("EPSG:" + this.site.epsg, projString);
      register(proj4);
    }
  }

getTirChange(event: number[]) {
  this.listeTirsSelectionnes = event;
  
  if (this.kpiDataLoaded) {
    this.DisplayBlastPolygons(this.listeTirsSelectionnes);
  } else {
    const waitForKPIData = () => {
      if (this.kpiDataLoaded) {
        this.DisplayBlastPolygons(this.listeTirsSelectionnes);
      } else {
        setTimeout(waitForKPIData, 100);
      }
    };
    waitForKPIData();
  }
  
  this.holeLayer.setSelectedBlast(this.listeTirsSelectionnes);
  this.RefreshHoles();
}

  getTypeChange() {
    // Mettre à jour les types sélectionnés avant d'afficher les polygones
    this.listeTypesSelectionnes = this.cartSelectedTirsPolygoneEnum.map(x => this.convertPolygonEnumToNumber(x));
    this.DisplayBlastPolygons(this.listeTirsSelectionnes);
    this.holeLayer.setSelectedBlast(this.listeTirsSelectionnes);
  }
private DisplayBlastPolygons(blastIdToDisplay?: number[], blastIdToZoom?: number) {
  this.fonctionsService.loading_screen(true);
  if (blastIdToDisplay != null && blastIdToDisplay != undefined && blastIdToDisplay.length > 0) {
    // Charger TOUS les types de polygones (pas seulement ceux sélectionnés)
    // Using actual numerical values from PolygonType enum
    const allPolygonTypes = [
      0, // AutomaticFromHoles (AUTOMATIC)
      1, // DrillingContour (DRILLED)
      2, // MuckPile (MUCKPILE)
      3  // DangerZone (DANGER_ZONE)
    ];
    
    this.blastPolygoneLayer.displayPolygonsForBlast(blastIdToDisplay, allPolygonTypes)
      .finally(() => {
        // Après chargement de tous les types, filtrer selon la sélection actuelle
        this.blastPolygoneLayer.filterPolygonsByType(this.listeTypesSelectionnes);
        
        this.RefreshHoles();
        this.fonctionsService.loading_screen(false);
        
        if (this.selectedKPI && !this.kpiSelectionne) {
          setTimeout(() => {
            this.getSelectedKPI(this.selectedKPI);
          }, 500);
        }
      });
      
      if (blastIdToZoom)
      {
        this.zoomOnSelectedBlast(blastIdToZoom);
      }
  }
  else {
    this.blastPolygoneLayer.hideAll();
    this.holeLayer.setSelectedBlast([]); 
    this.fonctionsService.loading_screen(false);
  }
}

  getSelectedKPI(event) {
    if (event != null) {
      this.kpiSelectionne = this.listeKPIActifs.find(e => e.referentielDonneeAnalyseId === event.referentielDonneeAnalyseId);
      
      this.selectedKPI = this.kpiSelectionne;
      
      if (this.listeKPITirs !== undefined) {
        this.getValeurKPITirs();
      }
      
      setTimeout(() => {
        this.updateKpiScaleGradient();
      }, 100);
      
    } else {
      this.kpiSelectionne = null;
      
      this.selectedKPI = null;
      
      this.borneInf = 0;
      this.borneSup = 100;
      this.borneMoy = null;
      this.valKPITir.update(v => ({ ...v, unite: "" }));
      let kpiJaugeElement = document.getElementById('kpi-jauge');
      if (kpiJaugeElement) {
        kpiJaugeElement.hidden = true;
      }
      this.blastPolygoneLayer.resetPolygonsKPIs();
      
      setTimeout(() => {
        this.updateKpiScaleGradient();
      }, 100);
    }
  }


getCentrerTir(event: number) {
  const polygonCenter = this.blastPolygoneLayer.getPolygonCenter(event);
  
  if (polygonCenter) {
    this.centerOnPolygon(event);

    const onMoveEnd = () => {
      this.map.un('moveend', onMoveEnd);
      const coordinates = polygonCenter;
      const coordinatesPanTo = this.getCoordonneesDecaleesZoom(coordinates);
      if (!this.modalPolygoneTypeisVisible) {
        this.createPopupTir(coordinates, event, coordinatesPanTo, false);
      }
    };

    this.map.on('moveend', onMoveEnd);
  } else {
    const coordinates = this.map.getView().getCenter() as Coordinate;
    const coordinatesPanTo = [coordinates[0], coordinates[1]];
    const popupCoordinates = this.getCoordonneesDecaleesZoom(coordinates, false);
    if (!this.modalPolygoneTypeisVisible) {
      this.createPopupTir(popupCoordinates, event, coordinatesPanTo, false);
    }
  }
}

  private centerOnPolygon(tirId: number): void {    
    const center = this.blastPolygoneLayer.getPolygonCenter(tirId);    
    if (center) {
      this.map.getView().animate({
        center: center,
        duration: 500
      });
    } 
  }

  private zoomToBlast(blastId: number): void {
    this.DisplayBlastPolygons(this.listeTirsSelectionnes, blastId);
  }

  public zoomOnSelectedBlast(tirId: number): void {
    const center = this.blastPolygoneLayer.getPolygonCenter(tirId);
    if (center) {
      this.map.getView().animate({
        center: center,
        zoom: 19,
        duration: 2000
      });
    }
  }

  getColorPolygon(valeurKPI) {
  let min = this.kpiSelectionne.valeurMin; 
  let max = this.kpiSelectionne.valeurMax; 
  let nom = this.kpiSelectionne.valeurNominal; 

  if (valeurKPI != null) {
    if (nom != null) {
      this.borneMoy = nom;
      if (min != null && max == null) {
        this.borneInf = min;
        this.borneSup = nom;
        this.borneMoy = null;
        return this.getKpiColorFromValue(valeurKPI, min, nom);
      }
      else if (max != null && min == null) {
        this.borneInf = nom;
        this.borneSup = max;
        this.borneMoy = null;
        return this.getKpiColorFromValue(valeurKPI, nom, max);
      }
    }
    if (min != null && max != null) {
      this.borneInf = min;
      this.borneSup = max;
      this.borneMoy = null;
      let couleur = this.getKpiColorFromValue(valeurKPI, min, max);
      return couleur;
    }
    return MapConstants.COULEUR_VIOLET_EPC;
  }
  else return MapConstants.COULEUR_VIOLET_EPC;
}

  private getKpiColorFromValue(kpiValue: number, minVal?: number, maxVal?: number): string {
    const min = minVal !== undefined ? minVal : this.borneInf;
    const max = maxVal !== undefined ? maxVal : this.borneSup;
    
    if (min === undefined || max === undefined) {
      return MapConstants.COULEUR_VIOLET_EPC;
    }
    
    kpiValue = Math.min(Math.max(kpiValue, min), max);
    const ratio = (kpiValue - min) / (max - min);
    
    if (isNaN(ratio) || ratio < 0 || ratio > 1) {
      return MapConstants.COULEUR_VIOLET_EPC;
    }
    
    const startHue = 300; 
    const endHue = 0; 
    const saturation = 80; 
    const lightness = 50; 
    
    const h = startHue + (endHue - startHue) * ratio;
    
    // Return in the expected format: "hue,saturation%,lightness%"
    return `${h},${saturation}%,${lightness}%`;
  }

  getValeurKPITirs() {
    this.valKPISelectionne = [];
    var unite = "";
    var min = 10000000000;
    var max = 0;
    
    if (this.kpiJauge?.nativeElement?.hidden) {
    this.kpiJauge.nativeElement.hidden = false;
  } else {
    const kpiJaugeElement = document.getElementById('kpi-jauge');
    if (kpiJaugeElement?.hidden) {
      kpiJaugeElement.hidden = false;
    }
  }

    this.showValKPITir = false;
    const tirs = this.listeTirs() ?? [];
    for (let i = 0; i < tirs.length; i++) {
      const kpi = this.listeKPITirs.find(element => element.referentielDonneeAnalyseId === this.kpiSelectionne.referentielDonneeAnalyseId && element.tirId === tirs[i].tirId);
      this.showValKPITir = (kpi !== undefined && !isNaN(Number(kpi.valeur))) || this.showValKPITir;
      if (kpi != undefined && kpi.valeur != null && kpi.valeur != "") {
        if (kpi.unite == null)
          unite = "";
        else
          unite = kpi.unite;
          const val = +kpi.valeur;
          if (max < val) max = val;
          if (min > val) min = val;
        if (this.kpiSelectionne.valeurMin == null && this.kpiSelectionne.valeurMax == null && this.kpiSelectionne.valeurNominal == null) {
          this.valKPISelectionne[i] = {
            idTir: tirs[i].tirId,
            valeur: kpi.valeur,
            unite: unite,
            couleur: MapConstants.COULEUR_VIOLET_EPC
          };
          let val = +this.valKPISelectionne[i].valeur;
          if (max < val) max = val;
          if (min > val) min = val;
        }
        else {
          this.valKPISelectionne[i] = {
            idTir: tirs[i].tirId,
            valeur: kpi.valeur,
            unite: unite,
            couleur: this.getColorPolygon(kpi.valeur)
          };

        }
      } else {
        this.valKPISelectionne[i] = {
          idTir: tirs[i].tirId,
          valeur: "",
          unite: "",
          couleur: MapConstants.COULEUR_VIOLET_EPC
        };

      }
    }
    
    if (undefined !== this.kpiSelectionne && null != this.kpiSelectionne) {
      if (this.kpiSelectionne.valeurMin == null && this.kpiSelectionne.valeurMax == null && this.kpiSelectionne.valeurNominal == null) {
        this.kpiSelectionne.valeurMin = min;
        this.kpiSelectionne.valeurMax = max;
        this.blastPolygoneLayer.setBlastKpis(this.valKPISelectionne, min, max);
      } else {
        this.showValKPITir = true;
        this.blastPolygoneLayer.setBlastKpis(this.valKPISelectionne, this.kpiSelectionne.valeurMin, this.kpiSelectionne.valeurMax);
      }
      
      this.UpdateKpiColorScale();
    }
  
  this.putValKPIPopup();
  }

  private UpdateKpiColorScale() {
  if (this.kpiSelectionne) {
    this.borneInf = this.kpiSelectionne.valeurMin || 0;
    this.borneSup = this.kpiSelectionne.valeurMax || 0;
    this.borneMoy = this.kpiSelectionne.valeurNominal || null;

    if (this.listeKPITirs && this.listeKPITirs.length > 0) {
      const kpiWithUnit = this.listeKPITirs.find(kpi => 
        kpi.referentielDonneeAnalyseId === this.kpiSelectionne.referentielDonneeAnalyseId && 
        kpi.unite !== null && kpi.unite !== undefined && kpi.unite !== ""
      );
      
      if (kpiWithUnit) {
        this.valKPITir.update(v => ({ ...v, unite: kpiWithUnit.unite }));
      }
    }

    // Update gradient after KPI values are updated
    this.updateKpiScaleGradient();
  }
}

  private updateKpiScaleGradient() {
      const scaleElement = document.getElementById('scale');
        const startColor = { h: 300, s: 80, l: 50 };
        const endColor = { h: 0, s: 80, l: 50 }; 
        
        const stops = [];
        const numStops = 20; 
        
        for (let i = 0; i <= numStops; i++) {
          const ratio = i / numStops;
          const h = startColor.h + (endColor.h - startColor.h) * ratio;
          const color = `hsl(${h}, ${startColor.s}%, ${startColor.l}%)`;
          const position = (ratio * 100).toFixed(1);
          stops.push(`${color} ${position}%`);
        }
        
        const gradient = `linear-gradient(to right, ${stops.join(', ')})`;
        if(!scaleElement) {
          return;
        }
        scaleElement.style.background = gradient;
  }

  inverserReferentielOuvert() {
    this.referentielOuvert = !this.referentielOuvert;
  }

  getCoordonneesDecaleesZoom(coordonnees: Coordinate, ajout = true): Coordinate {
    let zoom = this.view.getZoom();
    let difference = 0;
    let coordX = coordonnees[0];
    let coordY = coordonnees[1];
    if (zoom < 16) {
      difference = 500;
    }
    else if (zoom < 19) {
      difference = 100;
    }
    else {
      difference = 20;
    }
    if (ajout) {
      coordX += difference;
      coordY += difference;
    } else {
      coordX -= difference;
      coordY -= difference;
    }
    return [coordX, coordY];
  }

  public setActiveButton(buttonId: number): void {
    this.map.getTargetElement().classList.remove('map-drawing');
    
    if (buttonId === this.activeButton) {
      this.activeButton = 1;
      this.enablePolygonePicking = true;
      this.enableHoleInteraction = true;
      this.rulerControlLayer.stop();
      this.closePolygonTypeModal();
    }
    else if (buttonId === 2) {
      this.enablePolygonePicking = false;
      this.enableHoleInteraction = false;
      this.rulerControlLayer.toggle(MEASURE_MODE.line);
      this.activeButton = buttonId;
      this.closePolygonTypeModal();
    }
    else if (buttonId === 3) {
      this.enableHoleInteraction = false;
      this.openPolygonTypeModal();
      this.closePopup();
      this.activeButton = buttonId;
    }
    else if (buttonId === 1) {
      this.enablePolygonePicking = true;
      this.enableHoleInteraction = true;
      this.selectedPolygonFeature = undefined;
      this.rulerControlLayer.stop();
      this.activeButton = buttonId;
      this.closePolygonTypeModal();
    }
  }

  public setActiveBottomButton(buttonId: number): void {
    if (buttonId === this.bottomActiveButoon) {
      this.bottomActiveButoon = 0;
      this.showPopupForm.set(false);
      this.equipmentLayerManager.clear();
      // Masquer le layer d'équipement quand on désactive le mode
      this.equipmentLayerManager.setEquipmentsVisible(false);
      // Désactiver le mode neutre des polygones
      this.blastPolygoneLayer.setNeutralColorsEnabled(false);
      // Réactiver le toggle des holes
      this.holeToggle = true;
      if (this.inZoom) {
        this.holesAreShown = true;
        this.RefreshHoles();
      }
    }
    else if (buttonId === 3) {
      this.enablePolygonePicking = false;
      this.togglePopupForm();
      this.bottomActiveButoon = buttonId;
      // Rendre le layer d'équipement visible quand on active le mode
      this.equipmentLayerManager.setEquipmentsVisible(true);
      this.getEquipementPosition();
      // Activer le mode neutre des polygones
      this.blastPolygoneLayer.setNeutralColorsEnabled(true);
      // Désactiver le toggle des holes
      this.holeToggle = false;
      this.holesAreShown = false;
      this.RefreshHoles();
    }
    else if (buttonId === 1) {
      this.bottomActiveButoon = buttonId;
      this.showPopupForm.set(false);
      this.equipmentLayerManager.clear();
      // Désactiver le mode neutre des polygones
      this.blastPolygoneLayer.setNeutralColorsEnabled(false);
      // Réactiver le toggle des holes
      this.holeToggle = true;
      if (this.inZoom) {
        this.holesAreShown = true;
      }
      setTimeout(() => {
        this.updateKpiScaleGradient();
      }, 200);
    }
    else{
      this.bottomActiveButoon = buttonId;
      this.showPopupForm.set(false);
      this.equipmentLayerManager.clear();
      // Désactiver le mode neutre des polygones
      this.blastPolygoneLayer.setNeutralColorsEnabled(false);
      // Réactiver le toggle des holes
      this.holeToggle = true;
      if (this.inZoom) {
        this.holesAreShown = true;
      }

      if (buttonId === 2) {
        setTimeout(() => {
          this.evaluateHolesModalOverflow();
        }, 50);
      }
    }
    
  }

  public toggleLegend() {
    this.showLegend = !this.showLegend;
  }


  protected closeModalPolygoneType() {
    this.modalPolygoneTypeisVisible = false;
  }


  protected openModalValidationPolygone() {
    this.closePopup();
    this.modalValidationPrePolygoneisVisible = true;
    this.closePolygonTypeModal();


  }
  protected closeModalValidationPolygone() {
    this.enableHoleInteraction = true;
    this.modalValidationPrePolygoneisVisible = false;
    this.rulerControlLayer.stop()
    this.closePolygonTypeModal();

  }


  protected savePolygone() {
  let blastIdToUse: number;
  
  if (this.preSelectedBlast) {
    blastIdToUse = this.preSelectedBlast.tirId;
  } else if (this.selectedBlastForPolygon) {
    blastIdToUse = this.selectedBlastForPolygon;
  } else {
    alert('Please select a blast');
    return;
  }

  this.closeModalValidationPolygone();
  this.setActiveButton(1);
  this.view.setZoom(17);
  this.fonctionsService.loading_screen(true);
  
   
  let tirContour: TirContour = new TirContour();
  tirContour.format = MapConstants.EPSG_REFERENCE_OL;
  tirContour.coordonnees = StaticUtils.doubleCoordinateArrayToString(this.polygonCoordinatesToSave);

  if (this.selectedTirsPolygoneEnum === TirsPolygoneEnum.AUTOMATIC) {
    tirContour.typePolygone = PolygonType.AutomaticFromHoles;
  } else if(this.selectedTirsPolygoneEnum === TirsPolygoneEnum.DRILLED) {
    tirContour.typePolygone = PolygonType.DrillingContour;
  } else if (this.selectedTirsPolygoneEnum === TirsPolygoneEnum.MUCKPILE) {
    tirContour.typePolygone = PolygonType.MuckPile;
  } else if (this.selectedTirsPolygoneEnum === TirsPolygoneEnum.DANGER_ZONE) {
    tirContour.typePolygone = PolygonType.DangerZone;
  }

  this.http.post('Blasts/' + blastIdToUse + '/BlastOutlines', tirContour).subscribe({
    next: () => {
      this.fonctionsService.launch_toast(true);

        if (!this.cartSelectedTirsPolygoneEnum.includes(this.selectedTirsPolygoneEnum)) {
          this.cartSelectedTirsPolygoneEnum.push(this.selectedTirsPolygoneEnum);
        }
      
      this.listeTypesSelectionnes = this.cartSelectedTirsPolygoneEnum.map(x => this.convertPolygonEnumToNumber(x));
      this.blastPolygoneLayer.clear(); 

      this.blastPolygoneLayer.displayPolygonsForBlast(this.listeTirsSelectionnes, this.listeTypesSelectionnes, true).then(() => {
        this.clearDrawnPolygon();
        this.rulerControlLayer.stop()
        this.fonctionsService.loading_screen(false);
      });
    },
    error: () => {
      this.fonctionsService.launch_toast(false);
      this.fonctionsService.loading_screen(false);
      this.clearDrawnPolygon();  
      this.rulerControlLayer.stop()

    }
  });

  this.selectedPolygonFeature = undefined;
  this.selectedBlastForPolygon = null;
  this.preSelectedBlast = null;
  this.polygonCoordinatesToSave = [];
}
  protected cartPolygoneTypeChange() {
    this.listeTypesSelectionnes = this.cartSelectedTirsPolygoneEnum.map(x => this.convertPolygonEnumToNumber(x));
    
    // Debug: afficher les valeurs converties
    console.log('Selected enum values:', this.cartSelectedTirsPolygoneEnum);
    console.log('Converted to numbers:', this.listeTypesSelectionnes);
    
    // Filtrer les polygones déjà chargés côté client (pas d'appel API)
    this.blastPolygoneLayer.filterPolygonsByType(this.listeTypesSelectionnes);
    
    // Rafraîchir les holes instantanément
    this.RefreshHoles();
    
    // Mettre à jour les KPI instantanément
    if (this.kpiSelectionne) {
      this.getValeurKPITirs();
    } else if (this.selectedKPI) {
      this.getSelectedKPI(this.selectedKPI);
    }
  }

  protected closeMenuRightClick() {
    this.menuVisible = false;
  }

  togglePopupForm(): void {
    this.closePopup();

    if (!this.equipments || this.equipments.length === 0) {
      if (this.equipmentLayerManager) {
        this.equipmentLayerManager.fetchEquipments(this.site.siteId);
        this.equipmentLayerManager.dataLoaded.subscribe(() => {
          this.equipments = this.equipmentLayerManager.getEquipments();
          this.equipments = this.equipments?.map(equipment => ({
            ...equipment,
            displayName: EquipmentUtils.getEquipmentTypeFromEquipment(equipment) + " - " + EquipmentUtils.formatEquipmentDisplayName(equipment)
          }));
          this.showPopupForm.set(true);
          if (!this.selectedEquipments() || this.selectedEquipments().length === 0) {
            this.selectedEquipments.set(structuredClone(this.equipments));
          }
        });
      }
    } else {
      this.showPopupForm.set(true);
      if (!this.selectedEquipments() || this.selectedEquipments().length === 0) {
        this.selectedEquipments.set(structuredClone(this.equipments));
      }
    }
  }

  

  closePopupForm(): void {
    this.showPopupForm.set(false);
    this.selectedDate.set(undefined);
    this.selectedDateRange.set([]);
    this.selectedShift.set(undefined);
    this.shouldLoadSavedPositions = false;
    this.equipmentLayerManager.shouldLoadSavedPositions = this.shouldLoadSavedPositions;
    this.equipmentLayerManager.clear();
    this.saveBooleanToLocalStorage('showPopupForm', this.showPopupForm());
  }

  formatShiftLabel(shift: ShiftEnum): string {
    return ShiftUtils.formatShiftLabel(shift);
  }

  getDateFormat(): string {
    return StaticUtils.getDatePickerDateFormat(this.translate.currentLang);
  }

  // Fonction utilitaire pour formater les dates en dd/mm/yyyy
  private formatDateToDDMMYYYY(date: Date): string {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  compareFunction(item1: Equipment, item2: Equipment) {
    return item1 && item2 ? item1.equipementId === item2.equipementId : item1 === item2;
  }

  private createPopupEquipment(coordinates: Coordinate, positionData: EquipmentPosition) {
    if (this.modalValidationPrePolygoneisVisible) {
      return;
    }
    
    this.closePopup();
    const equipment = this.equipments.find(eq => eq.externalId === positionData.equipmentExternalId);
    this.equipmentDisplayName = equipment ? equipment.displayName : 'Unknown';
    this.equipmentName = equipment ? equipment.name : 'Unknown';
    this.equipmentExternalId = positionData.equipmentExternalId;
    this.currentEquipmentPosition = positionData;

    let positionDate: Date = positionData.date instanceof Date
      ? positionData.date
      : new Date(positionData.date);

    const timeFormat = StaticUtils.getTimeFormat(this.translate.currentLang);
    
    // Formatage manuel de la date en dd/mm/yyyy
    const day = positionDate.getDate().toString().padStart(2, '0');
    const month = (positionDate.getMonth() + 1).toString().padStart(2, '0');
    const year = positionDate.getFullYear();
    this.formattedDate = `${day}/${month}/${year}`;
    
    this.formattedTime = positionDate.toLocaleTimeString(this.translate.currentLang, timeFormat);
    this.equipmentLatitude = positionData.latitude;
    this.equipmentLongitude = positionData.longitude;

    this.checkEquipmentAssignment(positionData);

    this.popup.setPosition(coordinates);
    this.popupEquipmentActive.set(true);
    this.focusedEquipment.set(equipment)

  }

  private saveBooleanToLocalStorage(key: string, value: boolean) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  private savePolygonToggles() {
    localStorage.setItem('cartSelectedTirsPolygoneEnum', JSON.stringify(this.cartSelectedTirsPolygoneEnum));
  }

  private loadPolygonToggles() {
    const saved = localStorage.getItem('cartSelectedTirsPolygoneEnum');
    if (saved) {
      this.cartSelectedTirsPolygoneEnum = JSON.parse(saved);
    } else {
      this.cartSelectedTirsPolygoneEnum = [TirsPolygoneEnum.DRILLED, TirsPolygoneEnum.AUTOMATIC];
      this.savePolygonToggles();
    }
  }

  getEquipementPosition() {
    this.missingDateField = false;
    this.missingDateRangeField = false;
    this.missingShiftField = false;
    this.missingEquipmentField = false;

    if (this.timeSelection() === 'dateRange') {
      if (!this.selectedDateRange() || this.selectedDateRange().length < 2) {
        this.missingDateRangeField = true;
      }
      if (!this.selectedEquipments() || this.selectedEquipments().length === 0){
        this.missingEquipmentField = true;
      }
    } else if (this.timeSelection() === 'shift') {
      if (!this.selectedDate()) {
        this.missingDateField = true;
      }
      if (this.selectedShift() == undefined || this.selectedShift() == null){
        this.missingShiftField = true;
      }
      if (!this.equipments || this.equipments.length === 0){
        this.missingEquipmentField = true;
      }
    }

    if (this.missingDateField || this.missingDateRangeField || this.missingShiftField || this.missingEquipmentField) {
      if (this.equipmentLayerManager.getFeaturesCount() > 0) {
        this.equipmentLayerManager.clear();
      }
      this.hasAppliedFilters.set(false);
      return;
    }

    // En mode shift : charger tous les équipements pour avoir la liste complète,
    // puis après chargement sélectionner ceux qui ont des positions.
    const equipmentsToLoad = this.timeSelection() === 'shift' && this.equipments && this.equipments.length > 0
      ? this.equipments
      : this.selectedEquipments();

    const params = {
      selectedEquipments: equipmentsToLoad,
      selectedDate: this.selectedDate(),
      selectedDateRange: this.selectedDateRange(),
      selectedShift: this.selectedShift(),
      timeSelection: this.timeSelection(),
    };

    this.equipmentLayerManager.getEquipmentPositions(params);
    this.equipmentLayerManager.shouldLoadSavedPositions = true;
    this.hasAppliedFilters.set(true);

    // Activer l'affichage des routes après une recherche explicite
    if (this.showEquipmentRoutes) {
      this.equipmentLayerManager.setRoutesVisible(true);
    }

    // Mettre à jour la plage du slider de temps et appliquer le filtre initial
    this.updateTimeSliderRange();

    // Appliquer automatiquement les effets de timeline dès le chargement
    this.equipmentLayerManager.dataLoaded.pipe(take(1)).subscribe(() => {
      // Sélectionner tous les équipements présents sur ce shift
      this.selectedEquipments.set([...this.equipmentsWithPositions()]);
      this.updateEquipmentVisibility();
      this.applyTimelineEffects();
    });
  }

  /**
   * Appelé quand la date ou le shift change - applique automatiquement les filtres
   */
  onDateOrShiftChange(): void {
    // Appliquer automatiquement si date et shift sont sélectionnés
    if (this.selectedDate() && this.selectedShift() !== null && this.selectedShift() !== undefined) {
      this.equipmentRouteService.getRoutesBySiteId(this.site.siteId).subscribe({
        next: (savedRoutes) => {
          this.equipmentLayerManager.setSavedRoutes(savedRoutes);
          this.getEquipementPosition();
        },
        error: () => {
          this.getEquipementPosition();
        }
      });
    }
  }

  /**
   * Vérifie si on peut naviguer vers le shift précédent
   */
  canNavigateToPreviousShift(): boolean {
    if (!this.selectedDate() || this.selectedShift() === null || this.selectedShift() === undefined) {
      return false;
    }
    // On peut toujours aller en arrière (shift précédent ou jour précédent)
    return true;
  }

  /**
   * Vérifie si on peut naviguer vers le shift suivant
   */
  canNavigateToNextShift(): boolean {
    if (!this.selectedDate() || this.selectedShift() === null || this.selectedShift() === undefined) {
      return false;
    }
    // Vérifier si on n'est pas déjà au dernier shift de la date d'aujourd'hui
    const isToday = this.isSameDay(this.selectedDate(), new Date());
    const lastShiftIndex = this.shifts.length - 1;
    return !(isToday && this.selectedShift() === this.shifts[lastShiftIndex]);
  }

  /**
   * Navigue vers le shift précédent
   */
  navigateToPreviousShift(): void {
    if (!this.canNavigateToPreviousShift()) {
      return;
    }

    const currentShiftIndex = this.shifts.indexOf(this.selectedShift());

    if (currentShiftIndex > 0) {
      // Passer au shift précédent du même jour
      this.selectedShift.set(this.shifts[currentShiftIndex - 1] as ShiftEnum);
    } else {
      // Premier shift du jour, passer au dernier shift du jour précédent
      const previousDay = new Date(this.selectedDate());
      previousDay.setDate(previousDay.getDate() - 1);
      this.selectedDate.set(previousDay);
      this.selectedShift.set(this.shifts[this.shifts.length - 1] as ShiftEnum);
    }

    this.onDateOrShiftChange();
  }

  /**
   * Navigue vers le shift suivant
   */
  navigateToNextShift(): void {
    if (!this.canNavigateToNextShift()) {
      return;
    }

    const currentShiftIndex = this.shifts.indexOf(this.selectedShift());
    const lastShiftIndex = this.shifts.length - 1;

    if (currentShiftIndex < lastShiftIndex) {
      // Passer au shift suivant du même jour
      this.selectedShift.set(this.shifts[currentShiftIndex + 1] as ShiftEnum);
    } else {
      // Dernier shift du jour, passer au premier shift du jour suivant
      const nextDay = new Date(this.selectedDate());
      nextDay.setDate(nextDay.getDate() + 1);

      // Ne pas dépasser aujourd'hui
      if (nextDay <= this.today) {
        this.selectedDate.set(nextDay);
        this.selectedShift.set(this.shifts[0] as ShiftEnum);
      }
    }

    this.onDateOrShiftChange();
  }

  /**
   * Vérifie si deux dates sont le même jour
   */
  private isSameDay(date1: Date, date2: Date): boolean {
    return date1.getFullYear() === date2.getFullYear() &&
           date1.getMonth() === date2.getMonth() &&
           date1.getDate() === date2.getDate();
  }

  /**
   * Vérifie si un équipement a des positions
   */
  equipmentHasPositions(equipmentId: number): boolean {
    if (!this.equipmentLayerManager) {
      return false;
    }
    const positions = this.equipmentLayerManager.getAllPositions();
    return positions.some(p => p.equipmentExternalId === equipmentId);
  }

  /**
   * Retourne la liste des équipements qui ont des positions
   */
  equipmentsWithPositions = computed(() => {
    this.routesVersion(); // Dépendance signal pour recalculer quand les données changent
    if (!this.equipments || !this.equipmentLayerManager) {
      return [] as Equipment[];
    }
    const positions = this.equipmentLayerManager.getAllPositions();
    const equipmentIdsWithPositions = new Set(positions.map((p: EquipmentPosition) => p.equipmentExternalId));
    return this.equipments.filter(e => equipmentIdsWithPositions.has(e.externalId));
  });

  resetFilters() {
    this.selectedDate.set(undefined);
    this.selectedShift.set(undefined);
    this.selectedEquipments.set([]);
    this.hasAppliedFilters.set(false);
    this.timeSliderEnabled.set(false);

    if (this.equipmentLayerManager && this.equipmentLayerManager.getFeaturesCount() > 0) {
      this.equipmentLayerManager.clear();
    }
  }

  ngAfterViewChecked() {
  this.updateAllViewCheckboxState();
  
  this.checkAndApplyKpiGradient();
}

  private checkAndApplyKpiGradient() {
    if (this.bottomActiveButoon === 1) {
      const scaleElement = document.getElementById('scale');
      if (scaleElement && !scaleElement.style.background.includes('linear-gradient')) {
        this.updateKpiScaleGradient();
      }
    }
  }
  updateAllViewCheckboxState() {
  if (!this.allViewCheckbox) return;
  const total = this.equipmentsWithPositions()?.length || 0;
  const selected = this.selectedEquipments()?.length || 0;
  this.allViewCheckbox.nativeElement.indeterminate = selected > 0 && selected < total;
  this.allView.set(selected === total && total > 0);
}

  onAllViewToggle(): void {
    // Inverser l'état avant d'agir
    this.allView.update(v => !v);
    if (this.allView()) {
      // Cocher tous les équipements avec positions
      this.selectedEquipments.set([...this.equipmentsWithPositions()]);
    } else {
      // Décocher tous les équipements
      this.selectedEquipments.set([]);
    }
    // Mettre à jour l'état de la checkbox après modification
    this.updateAllViewCheckboxState();
    // Filtrer l'affichage sur la carte
    this.updateEquipmentVisibility();
  }

  onShowAssignedEquipmentsToggle(): void {
    // Forcer le rafraîchissement des styles pour masquer/afficher les équipements assignés
    if (this.equipmentLayerManager) {
      this.equipmentLayerManager.updateStylesBasedOnAssignmentFilter(this.showAssignedEquipments);
    }
  }

  onShowEquipmentRoutesToggle(): void {
    // Afficher ou masquer les routes entre les positions d'équipements
    if (this.equipmentLayerManager) {
      this.equipmentLayerManager.setRoutesVisible(this.showEquipmentRoutes);
    }
  }

  getRoutesForEquipment(equipmentId: number) {
    this.routesVersion(); // Lecture du signal pour déclencher le change detection en zoneless
    if (!this.equipmentLayerManager) {
      return [];
    }
    const routeLayer = this.equipmentLayerManager.getRouteLayer();
    return routeLayer.getRoutesForEquipment(equipmentId);
  }

  selectRoute(route: any) {
    if (this.equipmentLayerManager) {
      const routeLayer = this.equipmentLayerManager.getRouteLayer();
      routeLayer.selectRoute(route);
    }
  }

  zoomToRoute(route: EquipmentRoute): void {
    this.equipmentLayerManager?.getRouteLayer()?.zoomToRoute(route);
  }

  /**
   * Sélectionne ou fusionne une route depuis les cards
   */
  toggleRouteForMerge(route: EquipmentRoute, event: Event): void {
    event.stopPropagation();

    if (!this.routeSelectedForMerge()) {
      // Première route sélectionnée
      this.routeSelectedForMerge.set(route);
    } else if (this.routeSelectedForMerge() === route) {
      // Même route, désélectionner
      this.routeSelectedForMerge.set(null);
    } else if (this.routeSelectedForMerge().equipmentId !== route.equipmentId) {
      // Routes de différents équipements, changer la sélection
      this.routeSelectedForMerge.set(route);
    } else {
      // Deux routes du même équipement, fusionner
      this.mergeRoutesFromCards(this.routeSelectedForMerge(), route);
      this.routeSelectedForMerge.set(null);
    }
  }

  /**
   * Vérifie si une route est sélectionnée pour fusion
   */
  isRouteSelectedForMerge(route: EquipmentRoute): boolean {
    return this.routeSelectedForMerge() === route;
  }

  /**
   * Annule la sélection de route pour fusion
   */
  cancelMergeSelection(): void {
    this.routeSelectedForMerge.set(null);
  }

  /**
   * Fusionne deux routes depuis les cards
   */
  private mergeRoutesFromCards(route1: EquipmentRoute, route2: EquipmentRoute): void {
    if (!this.equipmentLayerManager) {
      return;
    }

    const routeLayer = this.equipmentLayerManager.getRouteLayer();

    // Récupérer les positions des deux routes
    const positions1 = route1.feature.get('positions') as EquipmentPosition[];
    const positions2 = route2.feature.get('positions') as EquipmentPosition[];

    if (!positions1 || !positions2) {
      console.warn('Positions manquantes pour la fusion');
      return;
    }

    // Combiner les positions et les trier chronologiquement
    const mergedPositions = [...positions1, ...positions2].sort((a, b) =>
      new Date(a.date).getTime() - new Date(b.date).getTime()
    );

    // Supprimer les anciennes routes via le layer (et en base si elles ont un ID)
    routeLayer.removeRoute(route1, true);
    routeLayer.removeRoute(route2, true);

    // Créer la nouvelle route fusionnée
    routeLayer.createMergedRoute(mergedPositions, route1.equipmentId, route1.equipmentName, route1.color);
  }

  formatRouteTime(date: Date): string {
    return `${date.getHours()}:${String(date.getMinutes()).padStart(2, '0')}`;
  }

  formatRouteDate(dayKey: string): string {
    // Format: YYYY-MM-DD_SHIFT (ex: 2024-09-18_night) ou ancien format YYYY-MM-DD
    const [datePart, shiftPart] = dayKey.split('_');
    const parts = datePart.split('-');
    const dateFormatted = `${parts[2]}/${parts[1]}`;

    // Si pas de shift (ancien format), retourner seulement la date
    if (!shiftPart) {
      return dateFormatted;
    }

    // Traduire le nom du shift
    const shiftNames: { [key: string]: string } = {
      'morning': 'Matin',
      'afternoon': 'Après-midi',
      'night': 'Nuit'
    };
    const shiftName = shiftNames[shiftPart] || shiftPart;

    return `${dateFormatted} - ${shiftName}`;
  }

  /**
   * Formate une date de blast pour l'affichage (DD/MM/YY)
   */
  formatBlastDate(date: Date | string): string {
    const d = new Date(date);
    const day = d.getDate().toString().padStart(2, '0');
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const year = d.getFullYear().toString().slice(2);
    return `${day}/${month}/${year}`;
  }

  /**
   * Récupère le nom d'un blast par son ID
   */
  getBlastNameById(tirId: number): string {
    const blast = this.listeTirs()?.find(tir => tir.tirId === tirId);
    return blast?.nom || `Blast ${tirId}`;
  }

  /**
   * Désassigne une route d'un blast
   */
  unassignRouteFromBlast(route: EquipmentRoute): void {
    if (!route.id) {
      // Route non sauvegardée, juste supprimer le tirId localement
      route.tirId = undefined;
      this.routesVersion.update(v => v + 1);
      return;
    }

    // Créer le DTO pour la mise à jour (sans tirId)
    const routeDto: EquipmentRouteDto = {
      id: route.id,
      siteId: this.site.siteId,
      equipmentId: route.equipmentId,
      start: route.startTime,
      end: route.endTime,
      tirId: null // Supprimer l'assignation
    };

    this.equipmentRouteService.updateRoute(route.id, routeDto).subscribe({
      next: () => {
        // Mettre à jour localement
        route.tirId = undefined;
        this.routesVersion.update(v => v + 1);
        console.log('Route désassignée avec succès');
      },
      error: (err) => {
        console.error('Erreur lors de la désassignation de la route:', err);
      }
    });
  }

  /**
   * Gère le début du drag d'une carte de route
   */
  onRouteDragStart(event: DragEvent, route: EquipmentRoute): void {
    this.draggingRoute.set(route);
    // Stocker l'ID de la route dans le dataTransfer pour le drop
    event.dataTransfer?.setData('text/plain', JSON.stringify({
      routeId: route.id,
      equipmentId: route.equipmentId,
      dayKey: route.dayKey,
      startTime: route.startTime,
      endTime: route.endTime
    }));
    event.dataTransfer!.effectAllowed = 'link';

    // Ajouter un listener temporaire sur la carte pour détecter le drop sur un polygone
    const mapElement = this.map.getTargetElement();
    mapElement.addEventListener('dragover', this.onMapDragOver);
    mapElement.addEventListener('drop', this.onMapDrop);
  }

  /**
   * Gère la fin du drag d'une carte de route
   */
  onRouteDragEnd(_event: DragEvent): void {
    // Retirer les listeners
    const mapElement = this.map.getTargetElement();
    mapElement.removeEventListener('dragover', this.onMapDragOver);
    mapElement.removeEventListener('drop', this.onMapDrop);

    this.draggingRoute.set(null);
    this.dragTooltipVisible = false;
  }

  /**
   * Handler pour dragover sur la carte (permet le drop et affiche la tooltip du blast)
   */
  private readonly onMapDragOver = (event: DragEvent): void => {
    event.preventDefault();
    event.dataTransfer!.dropEffect = 'link';

    // Afficher la tooltip du blast survolé
    const pixel = this.map.getEventPixel(event);
    let foundBlastInfo: { name: string; date: string } | null = null;

    this.map.forEachFeatureAtPixel(pixel, (feature) => {
      const featureType = feature.get(FEATURE_NAME);
      const featureType2 = feature.get(MapConstants.FEATURE_NAME);
      if (featureType === FEATURE_TYPE.blast_polygone ||
          featureType2 === MapConstants.FEATURE_TYPE.blast_polygone) {
        const tirIdObj = feature.get(MapConstants.TIR_ID);
        const tirId = tirIdObj?.value !== undefined ? tirIdObj.value : tirIdObj;
        if (tirId) {
          const tir = this.listeTirs()?.find(t => t.tirId === tirId);
          if (tir) {
            foundBlastInfo = {
              name: tir.nom || `Tir ${tirId}`,
              date: tir.dateTirPrevisionnelle ? this.formatBlastDate(tir.dateTirPrevisionnelle) : ''
            };
          }
        }
        return true;
      }
      return false;
    });

    if (foundBlastInfo) {
      this.dragTooltipVisible = true;
      this.dragTooltipText = foundBlastInfo.date
        ? `${foundBlastInfo.name} - ${foundBlastInfo.date}`
        : foundBlastInfo.name;
      this.dragTooltipX = event.clientX + 15;
      this.dragTooltipY = event.clientY + 15;
    } else {
      this.dragTooltipVisible = false;
    }
  };

  /**
   * Handler pour drop sur la carte - détecte si on est sur un polygone de blast
   */
  private readonly onMapDrop = (event: DragEvent): void => {
    event.preventDefault();

    if (!this.draggingRoute()) {
      return;
    }

    // Obtenir les coordonnées du drop sur la carte
    const pixel = this.map.getEventPixel(event);

    // Chercher un polygone de blast à cette position
    let foundFeature: any = null;
    this.map.forEachFeatureAtPixel(pixel, (feature) => {
      const featureType = feature.get(FEATURE_NAME);
      // Aussi checker avec MapConstants au cas où
      const featureType2 = feature.get(MapConstants.FEATURE_NAME);
      if (featureType === FEATURE_TYPE.blast_polygone ||
          featureType2 === MapConstants.FEATURE_TYPE.blast_polygone) {
        foundFeature = feature;
        return true; // Stop iteration
      }
      return false;
    });

    if (foundFeature) {
      // Récupérer le tirId du polygone
      const tirIdObj = foundFeature.get(MapConstants.TIR_ID);
      const tirId = tirIdObj?.value !== undefined ? tirIdObj.value : tirIdObj;

      if (tirId) {
        // Assigner la route à ce blast
        this.assignRouteToBlastById(this.draggingRoute(), tirId);
      }
    }

    this.draggingRoute.set(null);
  };

  /**
   * Assigne une route à un blast par son ID
   */
  assignRouteToBlastById(route: EquipmentRoute, tirId: number): void {
    if (!route.id) {
      // Route non sauvegardée, la créer d'abord avec le tirId
      const routeDto: EquipmentRouteDto = {
        siteId: this.site.siteId,
        equipmentId: route.equipmentId,
        start: route.startTime,
        end: route.endTime,
        tirId: tirId
      };

      this.equipmentRouteService.createRoute(routeDto).subscribe({
        next: (savedRoute) => {
          // Mettre à jour l'ID et le tirId dans la route locale
          route.id = savedRoute.id;
          route.tirId = tirId;
          this.routesVersion.update(v => v + 1);
          console.log('Route créée et assignée au blast:', savedRoute);
          this.fonctionsService.launch_toast(true);
        },
        error: (err) => {
          console.error('Erreur lors de la création de la route:', err);
          this.fonctionsService.launch_toast(false);
        }
      });
      return;
    }

    // Créer le DTO pour la mise à jour
    const routeDto: EquipmentRouteDto = {
      id: route.id,
      siteId: this.site.siteId,
      equipmentId: route.equipmentId,
      start: route.startTime,
      end: route.endTime,
      tirId: tirId
    };

    this.equipmentRouteService.updateRoute(route.id, routeDto).subscribe({
      next: () => {
        // Mettre à jour localement
        route.tirId = tirId;
        this.routesVersion.update(v => v + 1);
        console.log('Route assignée au blast avec succès:', tirId);
        this.fonctionsService.launch_toast(true);
      },
      error: (err) => {
        console.error('Erreur lors de l\'assignation de la route:', err);
        this.fonctionsService.launch_toast(false);
      }
    });
  }

  /**
   * Gère le clic sur une carte de route
   * En mode assignation, sélectionne la route pour assignation
   * Sinon, toggle la visibilité de la route
   */
  onRouteCardClick(route: EquipmentRoute): void {
    if (this.assignmentMode()) {
      // Mode assignation : sélectionner/désélectionner cette route pour assignation
      if (this.routeToAssignByClick() === route) {
        // Déselectionner si déjà sélectionnée
        this.routeToAssignByClick.set(null);
      } else {
        // Sélectionner cette route (une seule à la fois)
        this.routeToAssignByClick.set(route);
      }
    } else {
      // Mode normal : toggle la visibilité de la route
      this.selectRoute(route);
    }
  }

  /**
   * Bascule l'expansion d'une carte d'équipement
   */
  toggleEquipmentCard(equipmentId: number): void {
    this.expandedEquipmentCards.update(set => {
      const next = new Set(set);
      if (next.has(equipmentId)) {
        next.delete(equipmentId);
      } else {
        next.add(equipmentId);
      }
      return next;
    });
  }

  /**
   * Vérifie si une carte d'équipement est dépliée
   */
  isEquipmentCardExpanded(equipmentId: number): boolean {
    return this.expandedEquipmentCards().has(equipmentId);
  }

  /**
   * Obtient la couleur pour un équipement basé sur son ID
   * Utilise une palette de couleurs très distinctes
   */
  getEquipmentColor(equipmentId: number): string {
    const colors = [
      'rgba(230, 25, 75, 0.9)',    // Rouge vif
      'rgba(60, 180, 75, 0.9)',    // Vert vif
      'rgba(0, 130, 200, 0.9)',    // Bleu vif
      'rgba(255, 225, 25, 0.9)',   // Jaune vif
      'rgba(145, 30, 180, 0.9)',   // Violet
      'rgba(245, 130, 48, 0.9)',   // Orange
      'rgba(70, 240, 240, 0.9)',   // Cyan
      'rgba(240, 50, 230, 0.9)',   // Magenta
      'rgba(188, 246, 12, 0.9)',   // Lime
      'rgba(250, 190, 190, 0.9)',  // Rose
      'rgba(0, 128, 128, 0.9)',    // Teal
      'rgba(230, 190, 255, 0.9)',  // Lavande
      'rgba(154, 99, 36, 0.9)',    // Marron
      'rgba(255, 250, 200, 0.9)',  // Beige
      'rgba(128, 0, 0, 0.9)',      // Bordeaux
      'rgba(170, 255, 195, 0.9)',  // Menthe
      'rgba(128, 128, 0, 0.9)',    // Olive
      'rgba(255, 215, 180, 0.9)',  // Pêche
      'rgba(0, 0, 128, 0.9)',      // Navy
      'rgba(169, 169, 169, 0.9)'   // Gris
    ];
    return colors[equipmentId % colors.length];
  }

  /**
   * Bascule l'expansion du date range picker
   */
  toggleDateRangePicker(): void {
    this.isDateRangeExpanded.update(v => !v);
  }

  /**
   * Formate l'affichage de la date sélectionnée
   */
  formatSelectedDate(): string {
    if (!this.selectedDate()) {
      return 'Select date';
    }
    return this.formatDateShort(this.selectedDate());
  }

  /**
   * Formate l'affichage du shift sélectionné
   */
  formatSelectedShift(): string {
    if (this.selectedShift() === undefined || this.selectedShift() === null) {
      return 'Select shift';
    }
    return this.translate.instant(this.formatShiftLabel(this.selectedShift()));
  }

  /**
   * Formate une date courte (DD/MM/YYYY)
   */
  private formatDateShort(date: Date): string {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  /**
   * Réinitialise le date and shift picker
   */
  resetDateRange(): void {
    this.selectedDate.set(undefined);
    this.selectedShift.set(undefined);
    this.hasAppliedFilters.set(false);
  }

  /**
   * Applique la date et le shift sélectionné
   */
  applyDateRange(): void {
    // Vérifier que date et shift sont sélectionnés
    if (!this.selectedDate() || this.selectedShift() === undefined || this.selectedShift() === null) {
      return;
    }

    // Mettre la sélection en mode shift
    this.timeSelection.set('shift');

    // Pour le chargement, utiliser tous les équipements disponibles
    const equipmentsToLoad = this.equipments && this.equipments.length > 0
      ? this.equipments
      : this.selectedEquipments();

    if (this.equipmentLayerManager && equipmentsToLoad && equipmentsToLoad.length > 0) {
      const params = {
        selectedEquipments: equipmentsToLoad,
        selectedDate: this.selectedDate(),
        selectedDateRange: this.selectedDateRange(),
        selectedShift: this.selectedShift(),
        timeSelection: this.timeSelection(),
      };

      this.equipmentLayerManager.getEquipmentPositions(params);
      this.equipmentLayerManager.shouldLoadSavedPositions = true;
      this.hasAppliedFilters.set(true);

      // Activer l'affichage des routes si nécessaire
      if (this.showEquipmentRoutes) {
        this.equipmentLayerManager.setRoutesVisible(true);
      }

      // Activer le time slider
      this.timeSliderEnabled.set(true);
      this.updateTimeSliderRange();

      // Appliquer automatiquement les effets de timeline dès le chargement
      this.equipmentLayerManager.dataLoaded.pipe(take(1)).subscribe(() => {
        // Sélectionner automatiquement tous les équipements qui ont des positions
        this.selectedEquipments.set([...this.equipmentsWithPositions()]);
        // Mettre à jour la visibilité pour que tous les équipements avec positions soient visibles
        this.updateEquipmentVisibility();
        this.applyTimelineEffects();
      });
    }

    // Fermer le picker
    this.isDateRangeExpanded.set(false);
  }


  /**
   * Convertit des minutes depuis minuit en format HH:MM
   */
  formatTimeFromMinutes(minutes: number): string {
    const wrapped = ((minutes % 1440) + 1440) % 1440;
    const hours = Math.floor(wrapped / 60);
    const mins = wrapped % 60;
    return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
  }

  /**
   * Calcule le pourcentage de progression du slider
   */
  getSliderPercentage(): number {
    if (!this.timeSliderEnabled() || this.maxTime() === this.minTime()) {
      return 0;
    }

    return ((this.selectedTime() - this.minTime()) / (this.maxTime() - this.minTime())) * 100;
  }

  /**
   * Appelé quand le slider de temps change
   */
  onTimeSliderChange(): void {
    if (!this.timeSliderEnabled() || !this.equipmentLayerManager) {
      return;
    }
    this.filterPositionsByTime();
  }

  /**
   * Filtre les positions d'équipements en fonction du temps sélectionné
   */
  private filterPositionsByTime(): void {
    if (!this.equipmentLayerManager || !this.timeSliderEnabled()) {
      return;
    }

    // Créer une date de référence pour le filtrage
    // Pour le shift nuit, le startDate est sur J-1, on utilise directement le shiftRange
    const referenceDate = this.selectedDate() || new Date();
    const filterDate = new Date(referenceDate);
    const hours = Math.floor(this.selectedTime() / 60);
    if (hours >= 24) {
      // selectedTime > 24h signifie qu'on est passé minuit (ex: 22h+24=lendemain 5h)
      filterDate.setHours(hours - 24);
      filterDate.setMinutes(this.selectedTime() % 60);
    } else if (this.selectedShift() === ShiftEnum.NightToMorning && hours >= 22) {
      // Partie 22h-00h du shift nuit : c'est la veille de la date sélectionnée
      filterDate.setDate(filterDate.getDate() - 1);
      filterDate.setHours(hours);
      filterDate.setMinutes(this.selectedTime() % 60);
    } else {
      filterDate.setHours(hours);
      filterDate.setMinutes(this.selectedTime() % 60);
    }
    filterDate.setSeconds(0);

    // Filtrer les positions par temps (le slider ne touche QUE au style, pas à la visibilité)
    this.equipmentLayerManager.filterPositionsByTime(filterDate);
  }

  /**
   * Applique automatiquement les effets de timeline (tailles et opacités)
   * en positionnant le curseur au milieu de la plage de temps
   */
  private applyTimelineEffects(): void {
    if (!this.equipmentLayerManager || !this.timeSliderEnabled()) {
      return;
    }

    // Calculer le temps médian entre minTime et maxTime
    const medianTime = Math.floor((this.minTime() + this.maxTime()) / 2);
    this.selectedTime.set(medianTime);

    // Appliquer le filtre avec ce temps médian
    this.filterPositionsByTime();
  }

  /**
   * Calcule la plage de temps en fonction du shift sélectionné
   */
  private updateTimeSliderRange(): void {
    if (!this.selectedDate() && !this.selectedDateRange().length) {
      this.timeSliderEnabled.set(false);
      return;
    }

    this.timeSliderEnabled.set(true);

    if (this.selectedShift() !== undefined && this.selectedShift() !== null) {
      // Calculer la plage horaire en fonction du shift
      const shiftRange = ShiftUtils.calculateShiftTimeRange(this.selectedDate(), this.selectedShift());

      // Convertir en minutes depuis minuit
      this.minTime.set(shiftRange.startDate.getHours() * 60 + shiftRange.startDate.getMinutes());
      this.maxTime.set(shiftRange.endDate.getHours() * 60 + shiftRange.endDate.getMinutes());

      // Si le shift traverse minuit (comme Night shift)
      if (this.maxTime() < this.minTime()) {
        this.maxTime.update(v => v + 24 * 60); // Ajouter 24h
      }

      // Initialiser au début du shift
      this.selectedTime.set(this.minTime());
    } else {
      // Mode date range ou pas de shift: toute la journée
      this.minTime.set(0);
      this.maxTime.set(1439); // 23:59
      this.selectedTime.set(0);
    }
  }

  onTimeSelectionChange() {
    this.selectedShift.set(undefined);
    this.missingDateField = false;
    this.missingDateRangeField = false;
    this.missingShiftField = false;
    this.missingEquipmentField = false;
  }

  onDateChange(date: Date): void {
    this.selectedDate.set(date);
    this.getEquipementPosition();
  }

  onDateRangeChange(range: Date[]): void {
    if (!range || range.length !== 2) {
      return;
    }

    const hasChanged = !this.previousDateRange.length ||
                      this.previousDateRange[0]?.getTime() !== range[0]?.getTime() ||
                      this.previousDateRange[1]?.getTime() !== range[1]?.getTime();

    if (!hasChanged) {
      return;
    }

    if (this.dateRangeChangeTimeout) {
      clearTimeout(this.dateRangeChangeTimeout);
    }

    this.selectedDateRange.set(range);
    this.previousDateRange = [...range]; 


    this.getEquipementPosition();
 
  }
  public adjustDateRangePickerPosition(): void {
    setTimeout(() => this.startCalendarPositionMonitoring(), 50);
  }

  private checkAndAdjustCalendarPosition(): void {
    const container = document.querySelector('bs-daterangepicker-container') as HTMLElement;
    if (!container) return;

    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    const margin = 10; // marge de sécurité
    
    // Obtenir la position et taille actuelles
    const rect = container.getBoundingClientRect();
    
    // Vérifier si le calendrier déborde (avec une petite tolérance)
    const overflowRight = rect.right > (viewportWidth - margin);
    const overflowLeft = rect.left < margin;
    const overflowBottom = rect.bottom > (viewportHeight - margin);
    const overflowTop = rect.top < margin;

    // Toujours ajuster si il y a le moindre débordement
    if (overflowRight || overflowLeft || overflowBottom || overflowTop) {
      console.log(`Calendar overflow detected: right=${overflowRight}, left=${overflowLeft}, bottom=${overflowBottom}, top=${overflowTop}`);
      
      // Calculer la position optimale pour garantir que tout est visible
      let newLeft = rect.left;
      let newTop = rect.top;
      
      // Ajuster horizontalement - priorité au débordement le plus critique
      if (overflowRight) {
        // Le calendrier déborde à droite, le coller au bord droit
        newLeft = viewportWidth - rect.width - margin;
      }
      if (overflowLeft || newLeft < margin) {
        // Le calendrier déborde à gauche ou la nouvelle position est trop à gauche
        newLeft = margin;
      }
      
      // Ajuster verticalement
      if (overflowBottom) {
        // Le calendrier déborde en bas, le coller au bord bas
        newTop = viewportHeight - rect.height - margin;
      }
      if (overflowTop || newTop < margin) {
        // Le calendrier déborde en haut ou la nouvelle position est trop haute
        newTop = margin;
      }
      
      // S'assurer que les nouvelles coordonnées restent dans les limites
      newLeft = Math.max(margin, Math.min(newLeft, viewportWidth - rect.width - margin));
      newTop = Math.max(margin, Math.min(newTop, viewportHeight - rect.height - margin));
      
      // Appliquer la position corrigée
      container.style.position = 'fixed';
      container.style.left = `${newLeft}px`;
      container.style.top = `${newTop}px`;
      container.style.right = 'auto';
      container.style.bottom = 'auto';
      container.style.transform = 'none';
      container.style.zIndex = '1060';
      
      console.log(`Calendar repositioned from (${rect.left}, ${rect.top}) to (${newLeft}, ${newTop}), size: ${rect.width}x${rect.height}, viewport: ${viewportWidth}x${viewportHeight}`);
      
      // Vérification finale après repositionnement
      setTimeout(() => {
        const newRect = container.getBoundingClientRect();
        if (newRect.right > viewportWidth || newRect.bottom > viewportHeight || newRect.left < 0 || newRect.top < 0) {
          console.warn(`Calendar still overflows after adjustment: left=${newRect.left}, top=${newRect.top}, right=${newRect.right}, bottom=${newRect.bottom}`);
        }
      }, 50);
    }
  }

  private calendarMonitoringInterval: any;

  // Démarrer la surveillance ULTRA-AGRESSIVE du calendrier
  private startCalendarPositionMonitoring(): void {
    this.stopCalendarPositionMonitoring(); // S'assurer qu'on n'a pas déjà un interval
    
    // Forcer immédiatement
    this.forceCalendarInScreen();
    
    // Surveiller de manière très agressive - toutes les 50ms
    this.calendarMonitoringInterval = setInterval(() => {
      this.forceCalendarInScreen();
    }, 50);
    
    // Ajustements supplémentaires aux moments clés
    setTimeout(() => this.forceCalendarInScreen(), 10);
    setTimeout(() => this.forceCalendarInScreen(), 25);
    setTimeout(() => this.forceCalendarInScreen(), 75);
    setTimeout(() => this.forceCalendarInScreen(), 150);
    setTimeout(() => this.forceCalendarInScreen(), 300);
  }

  // Arrêter la surveillance
  private stopCalendarPositionMonitoring(): void {
    if (this.calendarMonitoringInterval) {
      clearInterval(this.calendarMonitoringInterval);
      this.calendarMonitoringInterval = null;
    }
  }

  // Juste décaler légèrement si le calendrier dépasse
  private forceCalendarInScreen(): void {
    const container = document.querySelector('bs-daterangepicker-container') as HTMLElement;
    if (!container) return;

    const viewportWidth = window.innerWidth;
    const rect = container.getBoundingClientRect();
    
    // Vérifier si ça dépasse à droite
    if (rect.right > viewportWidth) {
      const overflow = rect.right - viewportWidth;
      
      // Calculer la nouvelle position right pour rentrer dans l'écran
      // Si le calendrier est à "right: 100px" et déborde de 50px,
      // on doit mettre "right: 150px" pour le décaler de 50px vers la gauche
      const currentStyle = getComputedStyle(container);
      const currentRightValue = currentStyle.right;
      
      let currentRight: number;
      if (currentRightValue.includes('calc(')) {
        // Si c'est calc(77px + 1.2rem), approximer à 100px
        currentRight = 100;
      } else {
        currentRight = parseInt(currentRightValue) || 0;
      }
      
      const newRight = currentRight + overflow + 20; // +20px de marge de sécurité
      
      container.style.right = `${newRight}px`;
      console.log(`Calendar adjusted: viewport=${viewportWidth}, rect.right=${rect.right}, overflow=${overflow}, newRight=${newRight}px`);
    }
  }

  // Nettoyer quand le calendrier se ferme
  private cleanupCalendarPosition(): void {
    document.body.classList.remove('datepicker-open');
  }

  onShiftChange(shift: ShiftEnum): void {
    this.selectedShift.set(shift);
    this.getEquipementPosition();
  }
  onControlPointsToggleChange() {
    if (this.controlPointLayer) {
      this.controlPointLayer.setVisible(this.controlPointsToggle);
    }
    this.saveBooleanToLocalStorage('controlPointsToggle', this.controlPointsToggle);
  }

  onZoiToggleChange() {
    this.saveBooleanToLocalStorage('zoiToggle', this.zoiToggle);
    this.zoneOfInterestLayer.setVisible(this.zoiToggle);
  }

 onHolesToggleChange() {
  
  if (this.holeToggle && this.inZoom) {
    this.holesAreShown = true;
  } else {
    this.holesAreShown = false;
  }
  
  this.RefreshHoles();
  this.updateHoleVisibility();
}
  toggleEnumValue(value: TirsPolygoneEnum) {
  const index = this.cartSelectedTirsPolygoneEnum.indexOf(value);
  if (index === -1) {
    this.cartSelectedTirsPolygoneEnum.push(value);
  } else {
    this.cartSelectedTirsPolygoneEnum.splice(index, 1);
  }
  this.savePolygonToggles();
  this.cartPolygoneTypeChange(); 
  
}
  isSelected(item: Equipment): boolean {
    return this.selectedEquipments().some(e => e.equipementId === item.equipementId);
  }

  toggleSelection(item: Equipment): void {
  const index = this.selectedEquipments().findIndex(e => e.equipementId === item.equipementId);
  if (index > -1) {
    this.selectedEquipments.set(this.selectedEquipments().filter(e => e.equipementId !== item.equipementId));
  } else {
    this.selectedEquipments.set([...this.selectedEquipments(), item]); // Ajout non-mutatif
  }
  this.updateAllViewCheckboxState();
  // Filtrer l'affichage sur la carte
  this.updateEquipmentVisibility();
}

  updateEquipmentVisibility(): void {
    if (!this.equipmentLayerManager) {
      return;
    }

    // Récupérer les IDs des équipements sélectionnés
    const selectedIds = this.selectedEquipments().map(e => e.externalId).filter(id => id !== undefined);

    // Filtrer les équipements et routes visibles
    this.equipmentLayerManager.filterEquipmentsByIds(selectedIds);
  }

  private openPolygonTypeModal(): void {
    this.showPolygonTypeModal = true;
    this.selectedPolygonType = 'normal';
    this.selectAndStartPolygonType(this.selectedPolygonType) 
    if (this.menuTirSelected) {
      this.tirPopup.set(this.menuTirSelected);
    }
  }

  protected openHolesModal() {
    this.showHolesModal = true;
  }

  protected closeHolesModal() {
    this.showHolesModal = false;
  }

  protected onHoleStatusFilterChange(filter: string | HoleStatus) {
    this.selectedHoleStatusFilter = filter;
    this.selectedHoleFeatureFilter = 'all';
    this.updateHoleVisibility();
  }
  onHoleFeatureFilterChange(feature: string): void {
    this.selectedHoleFeatureFilter = feature;
    this.selectedHoleStatusFilter = 'actual';
    this.updateHoleVisibility();
    
    if (this.holeLayer && feature !== 'all') {
      setTimeout(() => {
        const features = this.holeLayer?.getAllHoleFeatures() || [];
        if (features.length > 0) {
          const totalHoles = features.length;
          let waterCount = 0;
          let tubeCount = 0;
          let deviationCount = 0;
          
          features.forEach(f => {
            const hole = f.get(MapConstants.HOLE_OBJECT);
            if (hole) {
              if (hole.hasWater) waterCount++;
              if (hole.hasTube) tubeCount++;
              if (hole.hasDeviation) deviationCount++;
            }
          });
          
          this.holeFeatureLegendProperties = [
            {
              featureType: 'water' as const,
              numberOfHoles: waterCount,
              percentage: Math.round((waterCount / totalHoles) * 100),
              totalHoles
            },
            {
              featureType: 'tube' as const,
              numberOfHoles: tubeCount,
              percentage: Math.round((tubeCount / totalHoles) * 100),
              totalHoles
            } ,
            { featureType: 'deviation' as const,
              numberOfHoles: deviationCount,
              percentage: Math.round((deviationCount / totalHoles) * 100),
              totalHoles
            } ,
          ];
        }
      }, 100);
    } else {
      this.holeFeatureLegendProperties = [];
    }
  }

  private getVisibleHoleStatuses(): Set<HoleStatus> {
    if (this.selectedHoleStatusFilter === 'actual') {
      return new Set(Object.values(HoleStatus));
    } else {
      return new Set([this.selectedHoleStatusFilter as HoleStatus]);
    }
  }

  protected updateHoleVisibility() {
    if (this.holesAreShown) {
      const visibleStatuses = this.getVisibleHoleStatuses();
      this.holeLayer.refreshHoleVisibility(visibleStatuses, this.selectedHoleStatusFilter as HoleStatus, this.selectedHoleFeatureFilter);
    } else {
      this.holeLayer.hideAllHoles();
      if (this.bottomActiveButoon === 2) {
        this.bottomActiveButoon = 0;
      }
    }
  }

  protected getHoleStatusList(): HoleStatus[] {
    return Object.values(HoleStatus);
  }

  getFeatureDisplayName(featureType: string): string {
    switch (featureType) {
      case 'water':
        return 'Water';
      case 'tube':
        return 'Tube';
      case 'both':
        return 'Water & Tube';
      case 'none':
        return 'No Features';
      default:
        return featureType;
    }
  }

  getFeatureIconPath(featureType: string): string {
    switch (featureType) {
      case 'water':
        return 'assets/icon/hole-water.svg';
      case 'tube':
        return 'assets/icon/hole-tube.svg';
      case 'both':
        return 'assets/icon/hole-water.svg'; 
      case 'none':
        return 'assets/icon/hole-others.svg';
      case 'deviation':
        return 'assets/icon/hole-deviation.svg';
      default:
        return 'assets/icon/hole-others.svg';
    }
  }

  public updateHoleFeatureLegend(): void {
    const features = this.holeLayer?.getAllHoleFeatures() || [];
    
    if (features.length === 0) {
      this.holeFeatureLegendProperties = [];
      return;
    }

    const totalHoles = features.length;
    const featureCount: { [key in 'water' | 'tube' | 'both' | 'none']: number } = {
      'water': 0,
      'tube': 0,
      'both': 0,
      'none': 0
    };

    features.forEach((feature, index) => {
      const hole = feature.get(MapConstants.HOLE_OBJECT);
      if (!hole) return;
      
      const hasWater = hole.hasWater || false;
      const hasTube = hole.hasTube || false;

      if (hasWater && hasTube) {
        featureCount.both++;
      } else if (hasWater) {
        featureCount.water++;
      } else if (hasTube) {
        featureCount.tube++;
      } else {
        featureCount.none++;
      }
    });

    this.holeFeatureLegendProperties = [
      {
        featureType: 'water' as const,
        numberOfHoles: featureCount.water,
        percentage: Math.round((featureCount.water / totalHoles) * 100),
        totalHoles
      },
      {
        featureType: 'tube' as const,
        numberOfHoles: featureCount.tube,
        percentage: Math.round((featureCount.tube / totalHoles) * 100),
        totalHoles
      }
    ];
  }


  public closePolygonTypeModal(): void {
    this.showPolygonTypeModal = false;
  }

  public selectAndStartPolygonType(type: string): void {
    this.activeButton = 3;
    this.map.getTargetElement().classList.add('map-drawing');
    this.selectedPolygonType = type;
    if (type === 'normal') {  
      this.rulerControlLayer.toggle(MEASURE_MODE.area);
      
      this.rulerControlLayer.drawPolygonCoordinatesEvent.subscribe({
        next: (coordinates: Coordinate[][]) => {
          this.polygonCoordinatesToSave = coordinates;
          this.handleDrawingComplete();
        },
        error: () => {
          this.handleDrawingError();
        }
      });
      
    } else if (type === 'circle') {
      this.rulerControlLayer.toggle(MEASURE_MODE.circle);
      
      this.listenForCircleDrawEnd();
    }
    
  }

  private listenForCircleDrawEnd(): void {
    const drawInteraction = this.rulerControlLayer.getDrawInteraction();
    
    if (drawInteraction) {
      drawInteraction.on('drawend', (event) => {
        const feature = event.feature;
        const geometry = feature.getGeometry();
        
        this.polygonCoordinatesToSave = this.extractCoordinatesFromGeometry(geometry);
        
        setTimeout(() => {
          this.handleDrawingComplete();
        }, 100);
      });
    }
  }

  private extractCoordinatesFromGeometry(geometry: any): Coordinate[][] {
    if (geometry.getType() === 'Circle') {
      const center = geometry.getCenter();
      const radius = geometry.getRadius();
      const points = 64; 
      const coordinates: Coordinate[] = [];
      
      for (let i = 0; i <= points; i++) {
        const angle = (i * 2 * Math.PI) / points;
        const x = center[0] + radius * Math.cos(angle);
        const y = center[1] + radius * Math.sin(angle);
        coordinates.push([x, y]);
      }
      
      coordinates[coordinates.length - 1] = [...coordinates[0]];
      
      return [coordinates];
      
    } else if (geometry.getType() === 'Polygon') {
      const coords = geometry.getCoordinates();
      return coords;
    } else {
      console.error('Unsupported geometry type:', geometry.getType());
      return [];
    }
  }

  private handleDrawingComplete(): void {
    if (this.menuTirSelected) {
      this.preSelectedBlast = this.menuTirSelected;
      this.selectedBlastForPolygon = this.menuTirSelected.tirId;
    } else if (this.tirPopup()) {
      this.preSelectedBlast = this.tirPopup()!;
      this.selectedBlastForPolygon = this.tirPopup()!.tirId;
    } else {
      this.preSelectedBlast = null;
      this.selectedBlastForPolygon = null;
    }
    
    if (!this.selectedTirsPolygoneEnum) {
      this.selectedTirsPolygoneEnum = TirsPolygoneEnum.MUCKPILE;
    }
    
    this.map.getTargetElement().classList.remove('map-drawing');
    this.activeButton = 1;
    this.enablePolygonePicking = true;
    
    this.openModalValidationPolygone();
  }

  private handleDrawingError(): void {
    this.map.getTargetElement().classList.remove('map-drawing');
    this.activeButton = 1;
    this.enablePolygonePicking = true;
    this.closePolygonTypeModal();
    this.fonctionsService.launch_toast(false);
    alert('An error occurred while drawing the polygon.');
  }

    private clearDrawnPolygon(): void {
    this.rulerControlLayer.clearDrawings();
    this.activeButton = 1;
    
}

checkScreenSize() {
  this.evaluateBottomButtonsOverflow();
}

private evaluateBottomButtonsOverflow(): void {
  requestAnimationFrame(() => {
    const rightMenu = document.querySelector('.right-menu') as HTMLElement;
    if (!rightMenu) return;

    const topButtons = rightMenu.querySelectorAll('.icon-button');
    let topUsed = 0;
    topButtons.forEach(btn => {
      const rect = (btn as HTMLElement).getBoundingClientRect();
      topUsed += rect.height; 
      const styles = window.getComputedStyle(btn as HTMLElement);
      topUsed += parseFloat(styles.marginTop) || 0;
      topUsed += parseFloat(styles.marginBottom) || 0;
    });

    const totalHeight = rightMenu.clientHeight;

    const availableForBottom = totalHeight - topUsed;
    
    if (availableForBottom <= 0) {
      if (!this.isBottomButtonsOverflow) {
        this.isBottomButtonsOverflow = true;
        this.cdr.detectChanges();
      }
      return;
    }

    const tempButtons = rightMenu.querySelectorAll('.right-menu-bottom:not(.overflow) .icon-button-bottom, .right-menu-bottom .icon-button-bottom');
    const uniqueButtons: HTMLElement[] = [];
    tempButtons.forEach(el => { if (!uniqueButtons.includes(el as HTMLElement)) uniqueButtons.push(el as HTMLElement); });
    if (!uniqueButtons.length) return;
    
    const needed = uniqueButtons.reduce((sum, el) => {
      const h = el.offsetHeight;
      const styles = window.getComputedStyle(el);
      const marginTop = parseFloat(styles.marginTop) || 0;
      const marginBottom = parseFloat(styles.marginBottom) || 0;
      return sum + h + marginTop + marginBottom;
    }, 0);

    let tolerance = 2;
    if (Math.abs(window.devicePixelRatio - 1.5) < 0.1) {
      tolerance = 10; 
    }
    
    const mustOverflow = needed > (availableForBottom - tolerance);
    
    if (mustOverflow) {
      const arrowsReserve = 64 + 8; 
      const candidate = availableForBottom - arrowsReserve;
      this.bottomButtonsViewportHeight = Math.max(candidate, 40); // sécurité
    } else {
      this.bottomButtonsViewportHeight = null;
    }
    
    if (mustOverflow !== this.isBottomButtonsOverflow) {
      this.isBottomButtonsOverflow = mustOverflow;
      this.cdr.detectChanges();
    }
  });
}

private evaluateTopButtonsOverflow(): void {
  requestAnimationFrame(() => {
    const container = this.topButtonsContainer?.nativeElement;
    const rightMenu = document.querySelector('.right-menu') as HTMLElement;
    if (!container || !rightMenu) return;
    const reservedForBottom = 120; 
    const available = rightMenu.clientHeight - reservedForBottom;
    const needed = container.scrollHeight;
    const overflow = needed > available;
    if (overflow !== this.isTopButtonsOverflow) {
      this.isTopButtonsOverflow = overflow;
      if (overflow) container.classList.add('top-scroll'); else container.classList.remove('top-scroll');
      this.cdr.detectChanges();
    }
  });
}

private evaluateHolesModalOverflow(): void {
  if (this.bottomActiveButoon !== 2) return;
  
  requestAnimationFrame(() => {
    const holesModal = document.querySelector('.modal-overlay-custome-holes') as HTMLElement;
    if (!holesModal) return;

    const rightMenu = document.querySelector('.right-menu') as HTMLElement;
    if (!rightMenu) return;

    const rightMenuRect = rightMenu.getBoundingClientRect();
    const modalRect = holesModal.getBoundingClientRect();
    
    const availableHeight = modalRect.top - rightMenuRect.top - 20;
    

    const neededHeight = modalRect.height;
    

    const mustOverflow = neededHeight > availableHeight;
    
    if (mustOverflow !== this.isHolesModalOverflow) {
      this.isHolesModalOverflow = mustOverflow;
      this.cdr.detectChanges();
    }
  });
}

private scheduleOverflowRecalc(): void {
  if (this.recalcTimeout) clearTimeout(this.recalcTimeout);
  
  this.recalcTimeout = setTimeout(() => { 
    this.adjustTopRightButtonsPosition();
    setTimeout(() => {
      this.evaluateBottomButtonsOverflow();
      this.evaluateTopButtonsOverflow();
      this.evaluateHolesModalOverflow();
    }, 10);
  }, 50);
}

private adjustTopRightButtonsPosition(): void {
  requestAnimationFrame(() => {
    const topRightButtons = document.querySelector('.top-right-buttons') as HTMLElement;
    if (!topRightButtons) return;

    const zoomFactor = window.devicePixelRatio;
    const baseDistance = 1; // 1rem de base
    

    const scaledDistance = baseDistance * Math.max(0.5, Math.min(1.5, 1 / Math.sqrt(zoomFactor)));
    
    topRightButtons.style.setProperty('--top-right-distance', `${scaledDistance}rem`);
    
    topRightButtons.classList.remove('zoom-high', 'zoom-low');
    
    if (zoomFactor > 2.0) {
      // Zoom très élevé
      topRightButtons.classList.add('zoom-high');
      topRightButtons.style.transform = `scale(${0.8})`;
      topRightButtons.style.setProperty('--top-right-gap', '0.25rem');
      topRightButtons.style.setProperty('--top-right-padding', '0.1rem 0.25rem');
    } else if (zoomFactor > 1.5) {
      // Zoom élevé
      topRightButtons.style.transform = `scale(${0.9})`;
      topRightButtons.style.setProperty('--top-right-gap', '0.3rem');
      topRightButtons.style.setProperty('--top-right-padding', '0.1rem 0.3rem');
    } else if (zoomFactor < 0.7) {
      // Zoom réduit
      topRightButtons.classList.add('zoom-low');
      topRightButtons.style.transform = `scale(${1.15})`;
      topRightButtons.style.setProperty('--top-right-gap', '0.6rem');
      topRightButtons.style.setProperty('--top-right-padding', '0.3rem 0.5rem');
    } else if (zoomFactor < 0.9) {
      // Zoom légèrement réduit
      topRightButtons.style.transform = `scale(${1.05})`;
      topRightButtons.style.setProperty('--top-right-gap', '0.55rem');
      topRightButtons.style.setProperty('--top-right-padding', '0.25rem 0.45rem');
    } else {
      // Zoom normal - réinitialiser aux valeurs par défaut
      topRightButtons.style.transform = 'scale(1)';
      topRightButtons.style.setProperty('--top-right-gap', '0.5rem');
      topRightButtons.style.setProperty('--top-right-padding', '0.2rem 0.4rem');
    }
  });
}

scrollToActiveButton() {
  if (this.isBottomButtonsOverflow) {
    const activeButton = document.querySelector('.icon-button-bottom.active');
    if (activeButton) {
      activeButton.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'center' 
      });
    }
  }
}
scrollUp() {
  if (this.isBottomButtonsOverflow && this.bottomButtonsContainer) {
    this.bottomButtonsContainer.nativeElement.scrollBy({ top: -40, behavior: 'smooth' });
  }
}

scrollDown() {
  if (this.isBottomButtonsOverflow && this.bottomButtonsContainer) {
    this.bottomButtonsContainer.nativeElement.scrollBy({ top: 40, behavior: 'smooth' });
  }
}

  toggleZoneColors(): void {
    this.useZoneColors = !this.useZoneColors;
    
    this.blastPolygoneLayer.setZoneColorsEnabled(this.useZoneColors);
    
    if (this.useZoneColors) {
      this.kpiSelectionne = null;
      this.selectedKPI = null;
      this.blastPolygoneLayer.resetPolygonsKPIs();
    } else {
      if (this.selectedKPI) {
        setTimeout(() => {
          this.getSelectedKPI(this.selectedKPI);
        }, 100);
      }
    }
  }

  private previousSelectedKPI: any = null;

  onColorModeChange(useZoneColors: boolean): void {
    this.useZoneColors = useZoneColors;
    
    this.blastPolygoneLayer.setZoneColorsEnabled(this.useZoneColors);
    
    if (this.useZoneColors) {
      if (this.selectedKPI) {
        this.previousSelectedKPI = this.selectedKPI;
      }
      this.kpiSelectionne = null;
      this.selectedKPI = null;
      this.blastPolygoneLayer.resetPolygonsKPIs();
    } else {
      if (this.previousSelectedKPI) {
        setTimeout(() => {
          this.getSelectedKPI(this.previousSelectedKPI);
        }, 100);
      } else if (this.selectedKPI) {
        setTimeout(() => {
          this.getSelectedKPI(this.selectedKPI);
        }, 100);
      }
    }
  }



  getZonesWithColors(): { zone: any, color: string }[] {
    if (!this.listeTirs()) return [];
    
    const zonesMap: { [key: number]: any } = {};
    
    this.listeTirs()?.forEach(tir => {
      if (tir.zoneId && !zonesMap[tir.zoneId]) {
        zonesMap[tir.zoneId] = {
          zoneId: tir.zoneId,
          nomZone: tir.nomZone || `Zone ${tir.zoneId}`
        };
      }
    });
    
    return Object.values(zonesMap).map(zone => ({
      zone,
      color: this.getZoneDisplayColor(zone.zoneId)
    }));
  }

  private getZoneDisplayColor(zoneId: number): string {
    if (zoneId && zoneId > 0 && ZoneColorPalette[zoneId]) {
      return ZoneColorPalette[zoneId];
    }
    return 'rgba(145, 40, 59, 0.8)'; // Couleur par défaut
  }
  setActiveTab(tab: string): void {
    this.activeTab = tab;
  }

  get orthoLayers(): OrthoPhotoDto[] {
    return this.mapLayersControler ? this.mapLayersControler.getOrthophotoMaps() : [];
  }

  dropOrthoLayer(event: CdkDragDrop<OrthoPhotoDto[]>) {
    const layers = [...this.orthoLayers];
    
    moveItemInArray(layers, event.previousIndex, event.currentIndex);
    

    layers.forEach((layer, index) => {
      layer.zOrder = index + 1;
    });
    
    this.mapLayersControler.updateOrthophotoOrder(layers);
    
    this.updateOrderInDatabase(layers);
    
  }

  private updateOrderInDatabase(layers: OrthoPhotoDto[]) {
    if (layers.length < 2) return;
    
    const orthophotosForApi = layers.map(layer => ({
      name: layer.mapName,
      ordre: layer.zOrder,
      guidProcess: layer.tileSetId,
      isActif: layer.isVisible
    }));
    
    const url = `sites/${this.utilService.currentSite().siteId}/map/order`;
    this.http.post(url, orthophotosForApi).subscribe((result: any) => {
      
        if (result.statusCode > 299) {
          this.fonctionsService.launch_toast(false, false, result.message);
        } else if (result.statusCode === 200 || result.statusCode === 204) {
          // 200 = OK avec contenu, 204 = No Content (succès sans retour)
          this.fonctionsService.launch_toast(true);
        }
      
      error: () => {
        this.fonctionsService.launch_toast(false);
      }
    });
  }

  toggleOrthoLayer(orthoPhoto: OrthoPhotoDto): void {
    const newVisibility = !orthoPhoto.isVisible;
    
    orthoPhoto.isVisible = newVisibility;
    
    this.mapLayersControler.toggleOrthophotoVisibility(orthoPhoto.id, newVisibility);
    
    const url = `sites/${this.utilService.currentSite().siteId}/map/${orthoPhoto.tileSetId}/visibility?isVisible=${newVisibility}`;
    this.http.post(url, {}).subscribe({
      next: (result: any) => {
        if (result.statusCode > 299) {
          orthoPhoto.isVisible = !newVisibility;
          this.mapLayersControler.toggleOrthophotoVisibility(orthoPhoto.id, !newVisibility);
          this.fonctionsService.launch_toast(false, false, result.message);
        } else if (result.statusCode === 200 || result.statusCode === 204) {
          this.fonctionsService.launch_toast(true);
        }
      },
      error: () => {
        orthoPhoto.isVisible = !newVisibility;
        this.mapLayersControler.toggleOrthophotoVisibility(orthoPhoto.id, !newVisibility);
        this.fonctionsService.launch_toast(false);
      }
    });
  }
  
  selectOrthoLayer(orthoPhoto: OrthoPhotoDto): void {
    if (this.selectedOrthoLayer === orthoPhoto) {
      this.selectedOrthoLayer = null;
    } else {
      this.selectedOrthoLayer = orthoPhoto;
    }
  }

  isOrthoLayerSelected(orthoPhoto: OrthoPhotoDto): boolean {
    return this.selectedOrthoLayer === orthoPhoto;
  }
  
  deleteOrthoLayer(orthoPhoto: OrthoPhotoDto): void {
    this.orthoToDelete = orthoPhoto;
    this.modalConfirmDeleteOrtho.show();
  }
  
  confirmDeleteOrthoLayer(): void {
    if (!this.orthoToDelete) return;
    
    this.fonctionsService.loading_screen(true);
    
    const file = {
      siteId: this.utilService.currentSite().siteId,
      guidProcess: this.orthoToDelete.tileSetId || '', 
      name: this.orthoToDelete.mapName,
      fileType: 'ORT' 
    };
    
    const url = "GeoData/DeleteLayer";
    this.http.put(url, file).subscribe({
      next: (result: any) => {
        this.fonctionsService.loading_screen(false);
        if (result.statusCode > 299) {
          this.fonctionsService.launch_toast(false, false, result.message);
        } else {
          const updatedLayers = this.orthoLayers.filter(layer => layer.id !== this.orthoToDelete.id);
          this.mapLayersControler.updateOrthophotoOrder(updatedLayers);
          
          this.fonctionsService.launch_toast(true);
          console.log(`Ortho layer ${this.orthoToDelete.mapName} deleted from database`);
        }
        this.modalConfirmDeleteOrtho.hide();
        this.orthoToDelete = null;
      },
      error: () => {
        this.fonctionsService.loading_screen(false);
        this.fonctionsService.launch_toast(false);
        this.modalConfirmDeleteOrtho.hide();
        this.orthoToDelete = null;
      }
    });
  }
  
  cancelDeleteOrthoLayer(): void {
    this.modalConfirmDeleteOrtho.hide();
    this.orthoToDelete = null;
  }
  
  openAddOrthophotosModal(): void {
    const initialState = {
      window: 1, 
      multi: false,
      types: ['.tif', '.tiff', '.geotiff']
    };
    
    const modalRef = this.modalService.show(SiteOrthophotosAddFilesModalComponent, { 
      initialState,
      class: 'custome-orto-modal modal-lg',
      backdrop: 'static',
      keyboard: false
    });
    
    modalRef.onHide?.subscribe((result: string) => {
      if (result !== 'cancel') {
        this.refreshOrthophotos();
      }
    });
  }
  
  private refreshOrthophotos(): void {
    if (this.mapLayersControler && this.utilService.currentSite()) {
      this.mapLayersControler.ChangeSite(this.utilService.currentSite());
    }
  }
  
  moveUp(zOrder: number) {
    const layers = [...this.orthoLayers];
    
    const currentIndex = layers.findIndex(layer => layer.zOrder === zOrder);
    if (currentIndex <= 0) return;
    moveItemInArray(layers, currentIndex, currentIndex - 1);
    
    layers.forEach((layer, idx) => {
      layer.zOrder = idx + 1;
    });
    
    this.mapLayersControler.updateOrthophotoOrder(layers);
    this.updateOrderInDatabase(layers);
    console.log('Move Up →', layers.map(l => `${l.mapName} (zOrder: ${l.zOrder})`));
  }

  moveDown(zOrder: number) {
    const layers = [...this.orthoLayers];
    
    const currentIndex = layers.findIndex(layer => layer.zOrder === zOrder);
    if (currentIndex >= layers.length - 1 || currentIndex === -1) return; 
    moveItemInArray(layers, currentIndex, currentIndex + 1);
    
    layers.forEach((layer, idx) => {
      layer.zOrder = idx + 1;
    });
    
    this.mapLayersControler.updateOrthophotoOrder(layers);
    this.updateOrderInDatabase(layers);
    console.log('Move Down →', layers.map(l => `${l.mapName} (zOrder: ${l.zOrder})`));
  }


  public deleteBlastPolygon(polygonId: number) {
    this.fonctionsService.loading_screen(true);
    this.http.delete('Blasts/BlastOutlines/' + polygonId).subscribe({
      next: () => {
        this.fonctionsService.launch_toast(true);
        this.blastPolygoneLayer.clear();
        this.blastPolygoneLayer.displayPolygonsForBlast(this.listeTirsSelectionnes, this.listeTypesSelectionnes, true).then(() => {
          this.fonctionsService.loading_screen(false);
        });
      },
      error: () => {
        this.fonctionsService.launch_toast(false);
        this.fonctionsService.loading_screen(false);
      }
    });
  }


  private checkEquipmentAssignment(positionData: EquipmentPosition) {
    this.equipmentAssignedShift = null;
    
    if (this.equipmentLayerManager) {
      const shifts = this.equipmentLayerManager.getShifts();
      const positionDate = new Date(positionData.date);
      
      this.equipmentAssignedShift = shifts.find(shift => {
        if (shift.isDeleted || !shift.equipementsIds) return false;
        
        const equipmentIds = shift.equipementsIds.split(';').map(id => parseInt(id.trim(), 10));
        const isEquipmentInShift = equipmentIds.includes(positionData.equipmentExternalId);
        
        if (!isEquipmentInShift) return false;
        
        const shiftDate = new Date(shift.date);
        
        if (shift.time === ShiftEnum.NightToMorning) {

          const positionHour = positionDate.getHours();
          const positionDateOnly = new Date(positionDate.getFullYear(), positionDate.getMonth(), positionDate.getDate());
          const shiftDateOnly = new Date(shiftDate.getFullYear(), shiftDate.getMonth(), shiftDate.getDate());
          const dayBeforeShift = new Date(shiftDateOnly.getTime() - 24 * 60 * 60 * 1000);
          
          if (positionHour >= 0 && positionHour < 6) {
            // Pour 0h-6h locales, le shift appartient à la veille (-1)
            return dayBeforeShift.getTime() === shiftDateOnly.getTime();
          }
          
          return false;
        } else {
          const timeRange = ShiftUtils.calculateShiftTimeRange(shiftDate, shift.time);
          return positionDate >= timeRange.startDate && positionDate <= timeRange.endDate;
        }
      }) || null;
    }
  }

 
  public getShiftDisplayName(shift: Shift): string {
    if (!shift) return '';
    
    const shiftName = ShiftUtils.formatShiftLabel(shift.time);
    const shiftDate = new Date(shift.date);
    const dateStr = this.formatDateToDDMMYYYY(shiftDate);
    
    return `${this.translate.instant(shiftName)} - ${dateStr}`;
  }


  public getBlastName(shift: Shift): string {
    if (!shift || !shift.tirId) return '';
    
    const tir = this.listeTirs()?.find(t => t.tirId === shift.tirId);
    return tir ? tir.nom || `Blast ${shift.tirId}` : `Blast ${shift.tirId}`;
  }

  public openAssignEquipmentModal() {
    if (!this.currentEquipmentPosition) return;
    
    this.assignmentMode.set(true);
    this.pendingEquipmentAssignment = this.currentEquipmentPosition;
    
    this.closePopup();

    this.map.getViewport().style.cursor = 'crosshair';
  }

 
  public assignEquipmentToShift(shift: Shift) {
    this.fonctionsService.loading_screen(true);
    
    this.http.post<Shift, Shift>('Blasts/shifts', shift).subscribe({
      next: (response) => {
        this.fonctionsService.launch_toast(true);
        this.fonctionsService.loading_screen(false);
        
        this.equipmentAssignedShift = { ...shift, shiftId: response.shiftId };
        
        if (this.equipmentLayerManager && this.currentEquipmentPosition) {
          const equipmentIds = [this.currentEquipmentPosition.equipmentExternalId];
          const updatedShift = { ...shift, shiftId: response.shiftId };
          
          const siteId = this.utilService.currentSite()?.siteId;
          this.equipmentLayerManager.forceLoadShifts(() => {
            this.equipmentLayerManager.applyAssignmentStyleImmediately(equipmentIds, true, this.showAssignedEquipments);
            
            setTimeout(() => {
              if (this.currentEquipmentPosition) {
                this.checkEquipmentAssignment(this.currentEquipmentPosition);
              }
            }, 100);
          }, siteId);
        }
      },
      error: (error) => {
        console.error('Error assigning equipment to shift:', error);
        this.fonctionsService.launch_toast(false);
        this.fonctionsService.loading_screen(false);
      }
    });
  }

  public unassignEquipment() {
    if (!this.equipmentAssignedShift || !this.currentEquipmentPosition) return;
    
    this.fonctionsService.loading_screen(true);
    
    const shiftId = this.equipmentAssignedShift.shiftId;
    const siteId = this.utilService.currentSite()?.siteId;
    
    if (!shiftId || !siteId) {
      this.fonctionsService.loading_screen(false);
      return;
    }
    
    const shiftToRemove = { ...this.equipmentAssignedShift };
    
    this.http.delete(`Blasts/${siteId}/shifts/${shiftId}`).subscribe({
      next: () => {
        this.fonctionsService.launch_toast(true);
        this.fonctionsService.loading_screen(false);
        
        if (this.equipmentLayerManager && this.currentEquipmentPosition) {
          const equipmentIds = [this.currentEquipmentPosition.equipmentExternalId];
          
          const siteId = this.utilService.currentSite()?.siteId;
          this.equipmentLayerManager.forceLoadShifts(() => {
            this.equipmentLayerManager.applyAssignmentStyleImmediately(equipmentIds, false, this.showAssignedEquipments);
            
            setTimeout(() => {
              if (this.currentEquipmentPosition) {
                this.checkEquipmentAssignment(this.currentEquipmentPosition);
              }
            }, 100);
          }, siteId);
        }

        this.equipmentAssignedShift = null;
      },
      error: (error) => {
        console.error('Error unassigning equipment from shift:', error);
        this.fonctionsService.launch_toast(false);
        this.fonctionsService.loading_screen(false);
      }
    });
  }


  public cancelAssignmentMode() {
    this.assignmentMode.set(false);
    this.pendingEquipmentAssignment = null;
    this.routeToAssignByClick.set(null); // Nettoyer la route sélectionnée
    this.map.getViewport().style.cursor = '';
  }

  /**
   * Active le mode assignation de route à un blast
   */
  public startRouteAssignmentMode(route: any): void {
    this.routeAssignmentMode = true;
    this.equipmentLayerManager.getRouteLayer().setAssignMode(true, route);
  }

  /**
   * Annule le mode assignation de route
   */
  public cancelRouteAssignmentMode(): void {
    this.routeAssignmentMode = false;
    this.equipmentLayerManager.getRouteLayer().setAssignMode(false);
    this.map.getViewport().style.cursor = '';
  }

  /**
   * Assigne la route sélectionnée à un blast
   */
  private assignRouteToBlast(tirId: number): void {
    const routeLayer = this.equipmentLayerManager.getRouteLayer();
    const route = routeLayer.getRouteToAssign();

    if (!route) {
      this.cancelRouteAssignmentMode();
      return;
    }

    // Si la route a un ID, faire un update, sinon créer
    if (route.id) {
      // Update de la route existante avec le tirId
      const routeDto: EquipmentRouteDto = {
        id: route.id,
        siteId: this.site.siteId,
        equipmentId: route.equipmentId,
        start: route.startTime,
        end: route.endTime,
        tirId: tirId
      };

      this.equipmentRouteService.updateRoute(route.id, routeDto).subscribe({
        next: (savedRoute) => {
          console.log('Route mise à jour avec le tirId:', savedRoute);
          // Mettre à jour le tirId dans la route locale
          route.tirId = tirId;
          this.routesVersion.update(v => v + 1);
          this.fonctionsService.launch_toast(true);
        },
        error: (error) => {
          console.error('Erreur lors de la mise à jour de la route:', error);
          this.fonctionsService.launch_toast(false);
        }
      });
    } else {
      // La route n'existe pas encore en base, la créer avec le tirId
      const routeDto: EquipmentRouteDto = {
        siteId: this.site.siteId,
        equipmentId: route.equipmentId,
        start: route.startTime,
        end: route.endTime,
        tirId: tirId
      };

      this.equipmentRouteService.createRoute(routeDto).subscribe({
        next: (savedRoute) => {
          console.log('Route créée et assignée au blast:', savedRoute);
          // Mettre à jour l'ID et le tirId dans la route locale
          route.id = savedRoute.id;
          route.tirId = tirId;
          this.routesVersion.update(v => v + 1);
          this.fonctionsService.launch_toast(true);
        },
        error: (error) => {
          console.error('Erreur lors de la création de la route:', error);
          this.fonctionsService.launch_toast(false);
        }
      });
    }

    this.cancelRouteAssignmentMode();
  }

  private assignEquipmentToBlast(tirId: number) {
    if (!this.pendingEquipmentAssignment) {
      this.cancelAssignmentMode();
      return;
    }

    const positionDate = new Date(this.pendingEquipmentAssignment.date);
    
    let shiftTime: ShiftEnum;
    let shiftDate = new Date(positionDate);
    // Utiliser l'heure locale au lieu de UTC pour correspondre à l'affichage utilisateur
    const hour = positionDate.getHours();
    
    if (hour >= 22 || hour < 6) {
      shiftTime = ShiftEnum.NightToMorning;
      if (hour >= 0 && hour < 6) {
        // Pour les positions entre 0h et 6h locales, -1 jour (le shift appartient à la veille)
        shiftDate.setDate(positionDate.getDate() - 1);
        shiftDate.setHours(0, 0, 0, 0);
      } else {
        // Pour 22h-23h locales, même date (début du shift de nuit)
        shiftDate.setHours(0, 0, 0, 0);
      }

    } else if (hour >= 6 && hour < 14) {
      shiftTime = ShiftEnum.MorningToAfternoon;
      shiftDate.setHours(0, 0, 0, 0);
    } else {
      shiftTime = ShiftEnum.AfternoonToEvening;
      shiftDate.setHours(0, 0, 0, 0);
    }

    const equipmentId = this.pendingEquipmentAssignment.equipmentExternalId;

    const conflictingShift = this.findConflictingShift(equipmentId, positionDate, shiftTime);
    
    const existingShift = this.findExistingShift(tirId, shiftDate, shiftTime);
    const deletedShift = this.findDeletedShift(tirId, shiftDate, shiftTime);
    
    if (existingShift) {
      this.addEquipmentToExistingShift(existingShift, equipmentId);
    } else if (deletedShift) {
      // Créer une date UTC qui représente la date locale pour éviter les problèmes de timezone
      const utcShiftDate = new Date(Date.UTC(
        shiftDate.getFullYear(),
        shiftDate.getMonth(),
        shiftDate.getDate(),
        0, 0, 0, 0
      ));
      
      // Réactiver un shift supprimé avec le nouvel équipement
      const reactivatedShift: Shift = {
        ...deletedShift,
        date: utcShiftDate,
        equipementsIds: this.pendingEquipmentAssignment.equipmentExternalId.toString(),
        isDeleted: false
      };
      
      this.reactivateDeletedShift(reactivatedShift);
    } else {
      // Créer une date UTC qui représente la date locale pour éviter les problèmes de timezone
      const utcShiftDate = new Date(Date.UTC(
        shiftDate.getFullYear(),
        shiftDate.getMonth(),
        shiftDate.getDate(),
        0, 0, 0, 0
      ));
      
      const newShift: Shift = {
        date: utcShiftDate,
        time: shiftTime,
        tirId: tirId,
        siteId: this.utilService.currentSite()?.siteId || 0,
        equipementsIds: this.pendingEquipmentAssignment.equipmentExternalId.toString(),
        equipeId: 0,
        operatorId: 0,
        isDeleted: false
      };
      
      this.assignEquipmentToShift(newShift);
    }
    
    this.cancelAssignmentMode();
  }


  private findConflictingShift(equipmentId: number, date: Date, shiftTime: ShiftEnum): Shift | null {
    if (!this.equipmentLayerManager) {
      return null;
    }

    const shifts = this.equipmentLayerManager.getShifts();
    const targetDate = new Date(date);
    targetDate.setHours(0, 0, 0, 0);

    return shifts.find(shift => {
      if (shift.isDeleted || shift.time !== shiftTime) {
        return false;
      }

      const shiftDate = new Date(shift.date);
      shiftDate.setHours(0, 0, 0, 0);
      
      if (shiftDate.getTime() !== targetDate.getTime()) {
        return false;
      }

      const equipmentIds = shift.equipementsIds 
        ? shift.equipementsIds.split(';').map(id => parseInt(id.trim(), 10))
        : [];
      
      return equipmentIds.includes(equipmentId);
    }) || null;
  }

  private findExistingShift(tirId: number, date: Date, shiftTime: ShiftEnum): Shift | null {
    if (!this.equipmentLayerManager) {
      return null;
    }

    const shifts = this.equipmentLayerManager.getShifts();
    const targetDate = new Date(date);
    targetDate.setHours(0, 0, 0, 0); 

    return shifts.find(shift => {
      if (shift.isDeleted || shift.tirId !== tirId || shift.time !== shiftTime) {
        return false;
      }

      const shiftDate = new Date(shift.date);
      shiftDate.setHours(0, 0, 0, 0);
      
      return shiftDate.getTime() === targetDate.getTime();
    }) || null;
  }

  private findDeletedShift(tirId: number, date: Date, shiftTime: ShiftEnum): Shift | null {
    if (!this.equipmentLayerManager) {
      return null;
    }

    const shifts = this.equipmentLayerManager.getShifts();
    const targetDate = new Date(date);
    targetDate.setHours(0, 0, 0, 0); 

    return shifts.find(shift => {
      if (!shift.isDeleted || shift.tirId !== tirId || shift.time !== shiftTime) {
        return false;
      }

      const shiftDate = new Date(shift.date);
      shiftDate.setHours(0, 0, 0, 0);
      
      return shiftDate.getTime() === targetDate.getTime();
    }) || null;
  }

  private reactivateDeletedShift(shift: Shift) {
    this.fonctionsService.loading_screen(true);
    
    this.http.put<Shift, Shift>('Blasts/shifts', shift).subscribe({
      next: (response) => {
        this.fonctionsService.launch_toast(true);
        this.fonctionsService.loading_screen(false);
        
        this.equipmentAssignedShift = response;
        
        if (this.equipmentLayerManager && this.currentEquipmentPosition) {
          const equipmentIds = [this.currentEquipmentPosition.equipmentExternalId];
          
          const siteId = this.utilService.currentSite()?.siteId;
          // D'abord recharger les shifts depuis le serveur
          this.equipmentLayerManager.fetchShifts(siteId, () => {
            // Puis appliquer le style une fois les shifts rechargés
            this.equipmentLayerManager.applyAssignmentStyleImmediately(equipmentIds, true, this.showAssignedEquipments);
          });
        }
      },
      error: (error) => {
        console.error('Erreur lors de la réactivation du shift:', error);
        this.fonctionsService.launch_toast(false);
        this.fonctionsService.loading_screen(false);
      }
    });
  }


  private addEquipmentToExistingShift(existingShift: Shift, equipmentExternalId: number) {
    if (!existingShift.shiftId) {
      console.error('Cannot add equipment to shift: shift has no ID');
      return;
    }

    const currentEquipmentIds = existingShift.equipementsIds 
      ? existingShift.equipementsIds.split(';').map(id => parseInt(id.trim(), 10))
      : [];

    if (currentEquipmentIds.includes(equipmentExternalId)) {
      this.fonctionsService.launch_toast(true); // Toast de succès car l'équipement est déjà assigné
      return;
    }

    const updatedEquipmentIds = [...currentEquipmentIds, equipmentExternalId].join(';');
    
    const updatedShift: Shift = {
      ...existingShift,
      equipementsIds: updatedEquipmentIds
    };


    this.fonctionsService.loading_screen(true);
    
    this.http.put<Shift, Shift>('Blasts/shifts', updatedShift).subscribe({
      next: (response) => {
        this.fonctionsService.launch_toast(true);
        this.fonctionsService.loading_screen(false);
        
        this.equipmentAssignedShift = updatedShift;
        
        if (this.equipmentLayerManager && this.currentEquipmentPosition) {
          const equipmentIds = [this.currentEquipmentPosition.equipmentExternalId];
          
          const siteId = this.utilService.currentSite()?.siteId;
          this.equipmentLayerManager.forceLoadShifts(() => {
            this.equipmentLayerManager.applyAssignmentStyleImmediately(equipmentIds, true, this.showAssignedEquipments);
            
            setTimeout(() => {
              if (this.currentEquipmentPosition) {
                this.checkEquipmentAssignment(this.currentEquipmentPosition);
              }
            }, 100);
          }, siteId);
        }
      },
      error: (error) => {
        this.fonctionsService.launch_toast(false);
        this.fonctionsService.loading_screen(false);
      }
    });
  }

  private initializeEquipmentLayer(): void {
    this.showEquipmentButton = true;
    this.equipmentLayerManager = 
        !this.equipmentLayerManager ? 
        new BlastEquipmentLayer(this.map, this.http, this.translate, this.logger, this.getDynamicZIndex(60))
        : this.equipmentLayerManager;

    this.equipmentLayerManager.dataLoaded.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.equipments = this.equipmentLayerManager.getEquipments();
      this.routesVersion.update(v => v + 1);
    });
    this.equipmentLayerManager.dataLoading.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(isLoading => {
      this.loadingEquipments = isLoading;
    });

    // S'abonner à l'événement de split terminé
    this.equipmentLayerManager.getRouteLayer().splitCompleted.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.splitRouteMode.set(false); // Désactiver le bouton split
      // Rafraîchir les styles des positions pour qu'elles prennent les nouvelles couleurs des routes
      this.equipmentLayerManager.forceStyleRefresh();
      this.routesVersion.update(v => v + 1);
    });

    // S'abonner à l'événement de merge terminé
    this.equipmentLayerManager.getRouteLayer().mergeCompleted.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.mergeRouteMode = false; // Désactiver le bouton merge
      this.routeSelectedForMerge.set(null); // Réinitialiser la sélection de fusion
      // Rafraîchir les styles des positions pour qu'elles prennent les nouvelles couleurs des routes
      this.equipmentLayerManager.forceStyleRefresh();
      this.routesVersion.update(v => v + 1);
    });

    // S'abonner à l'événement de sauvegarde des routes
    this.equipmentLayerManager.getRouteLayer().routesSaveRequired.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((routes: EquipmentRouteDto[]) => {
      // Ajouter le siteId aux routes avant de sauvegarder
      const routesWithSiteId = routes.map(route => ({
        ...route,
        siteId: this.site.siteId
      }));
      this.equipmentRouteService.saveRoutes(routesWithSiteId).subscribe({
        next: (savedRoutes) => {
          console.log('Routes sauvegardées avec succès:', savedRoutes);
          // Mettre à jour les IDs des routes en mémoire avec les IDs retournés par le serveur
          savedRoutes.forEach(savedRoute => {
            const matchingRoute = this.equipmentLayerManager.getRouteLayer().getRoutes().find(r =>
              r.equipmentId === savedRoute.equipmentId &&
              r.startTime.getTime() === new Date(savedRoute.start).getTime() &&
              r.endTime.getTime() === new Date(savedRoute.end).getTime() &&
              !r.id
            );
            if (matchingRoute) {
              matchingRoute.id = savedRoute.id;
            }
          });
          // Synchroniser les savedRoutes pour que createRoutesFromPositions reste cohérent
          this.equipmentLayerManager.addSavedRoutes(savedRoutes);
        },
        error: (err) => {
          console.error('Erreur lors de la sauvegarde des routes:', err);
        }
      });
    });

    // S'abonner à l'événement de suppression des routes
    this.equipmentLayerManager.getRouteLayer().routesDeleteRequired.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((routeIds: number[]) => {
      // Retirer immédiatement des savedRoutes pour garder la cohérence
      this.equipmentLayerManager.removeSavedRoutes(routeIds);
      routeIds.forEach(routeId => {
        this.equipmentRouteService.deleteRoute(routeId).subscribe({
          next: () => {
            console.log('Route supprimée avec succès:', routeId);
          },
          error: (err) => {
            console.error('Erreur lors de la suppression de la route:', routeId, err);
          }
        });
      });
    });

    // Définir le siteId sur le layer pour les futures sauvegardes
    this.equipmentLayerManager.getRouteLayer().setSiteId(this.site.siteId);

    // Charger les routes sauvegardées avant de charger les positions
    this.equipmentRouteService.getRoutesBySiteId(this.site.siteId).subscribe({
      next: (savedRoutes) => {
        console.log('Routes sauvegardées chargées:', savedRoutes);
        this.equipmentLayerManager.setSavedRoutes(savedRoutes);
        // Maintenant charger les équipements et positions
        this.equipmentLayerManager.fetchEquipments(this.site.siteId);
        this.equipmentLayerManager.loadAndApplySavedPositions();
      },
      error: (err) => {
        console.error('Erreur lors du chargement des routes sauvegardées:', err);
        // Charger quand même les équipements sans routes sauvegardées
        this.equipmentLayerManager.fetchEquipments(this.site.siteId);
        this.equipmentLayerManager.loadAndApplySavedPositions();
      }
    });
  }

  // --- Zone of Interest ---

  protected startZOIDrawing(): void {
    this.showZoiTypeModal = !this.showZoiTypeModal;
  }

  protected selectAndStartZOIType(type: string): void {
    this.showZoiTypeModal = false;
    this.activeButton = 4;
    this.map.getTargetElement().classList.add('map-drawing');

    if (type === 'normal') {
      this.zoiGeometryType = 'polygon';
      this.rulerControlLayer.toggle(MEASURE_MODE.area);

      this.rulerControlLayer.drawPolygonCoordinatesEvent.pipe(take(1)).subscribe({
        next: (coordinates: Coordinate[][]) => {
          const drawnPolygon = new OlPolygon(coordinates);
          const wkt = new WKTFormat();
          this.zoiWkt = wkt.writeGeometry(drawnPolygon);
          this.zoiCenterX = undefined;
          this.zoiCenterY = undefined;
          this.zoiRadius = undefined;
          this.openZoiModal();
        }
      });
    } else if (type === 'circle') {
      this.zoiGeometryType = 'circle';
      this.rulerControlLayer.toggle(MEASURE_MODE.circle);

      this.rulerControlLayer.drawCircleDataEvent.pipe(take(1)).subscribe({
        next: (data: { center: Coordinate; radius: number }) => {
          this.zoiCenterX = data.center[0];
          this.zoiCenterY = data.center[1];
          this.zoiRadius = data.radius;
          this.zoiWkt = undefined;
          this.openZoiModal();
        }
      });
    }
  }

  private openZoiModal(): void {
    this.map.getTargetElement().classList.remove('map-drawing');
    this.activeButton = 1;
    this.zoiName = '';
    this.zoiType = 0;
    this.zoiThreshold = 30;
    this.zoiModalVisible = true;
  }

  protected closeZoiModal(): void {
    this.zoiModalVisible = false;
    this.rulerControlLayer.stop();
  }

  protected saveZoneOfInterest(): void {
    const dto: ZoneOfInterestDto = {
      id: 0,
      name: this.zoiName,
      type: this.zoiType,
      geometryType: this.zoiGeometryType,
      centerX: this.zoiCenterX,
      centerY: this.zoiCenterY,
      radius: this.zoiRadius,
      wktString: this.zoiWkt,
      detectionThresholdSeconds: this.zoiThreshold,
      isActive: true
    };

    this.zoiService.create(this.site.siteId, dto).subscribe({
      next: () => {
        this.fonctionsService.launch_toast(true);
        this.zoiModalVisible = false;
        this.rulerControlLayer.stop();
        this.zoneOfInterestLayer.refresh();
      },
      error: () => {
        this.fonctionsService.launch_toast(false);
      }
    });
  }

}